// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otc-trade-desk.otc-desk-page {
  min-height: calc(100vh - 70px);
}

.otc-trade-shell {
  background:
    radial-gradient(ellipse 80% 50% at 10% -10%, rgba(213, 167, 96, 0.14), transparent 55%),
    radial-gradient(ellipse 60% 40% at 90% 0%, rgba(209, 170, 103, 0.08), transparent 50%),
    #12151b;
  color: #f5f5f5;
  padding: 24px 20px 48px;
}

.otc-trade-shell--orders {
  background: transparent;
  padding: 0;
  min-height: 0;
}

.otc-trade-shell__inner {
  width: min(1180px, 100%);
  margin: 0 auto;
}

.otc-trade-shell--orders .otc-trade-shell__inner {
  width: 100%;
  max-width: none;
  margin: 0;
}

.otc-desk-flow {
  position: relative;
}

.otc-desk-flow__hero {
  position: relative;
  margin: 0 0 22px;
  padding: 4px 0 2px;
}

.otc-desk-flow__kicker {
  margin: 0 0 8px;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #d5a760;
}

.otc-desk-flow .so-page__title {
  margin: 0 0 8px;
  background: linear-gradient(120deg, #fff 20%, #e7c98a 85%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.otc-desk-flow__lead {
  margin: 0;
  max-width: 62ch;
  color: #9ca3af;
  font-size: 0.92rem;
  line-height: 1.45;
}

.otc-flow-steps {
  position: relative;
  margin: 0 0 22px;
  padding: 20px 14px 16px;
  border-radius: 18px;
  border: 1px solid rgba(213, 167, 96, 0.22);
  background:
    radial-gradient(ellipse 70% 80% at 10% 0%, rgba(213, 167, 96, 0.12), transparent 55%),
    linear-gradient(180deg, rgba(28, 32, 40, 0.98), rgba(18, 21, 27, 0.96));
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);
}

.otc-flow-steps__track {
  position: absolute;
  top: 34px;
  left: 12.5%;
  right: 12.5%;
  height: 3px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  overflow: hidden;
  pointer-events: none;
}

.otc-flow-steps__track-fill {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #d5a760, #e7c98a);
  box-shadow: 0 0 12px rgba(231, 201, 138, 0.45);
  transition: width 0.28s ease;
}

.otc-flow-steps__list {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0;
  margin: 0;
  padding: 0;
  list-style: none;
}

.otc-flow-steps__list li {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
  color: #9ca3af;
  min-width: 0;
  padding: 0 4px;
}

.otc-flow-steps__num {
  display: inline-grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: #12151b;
  color: #d5a760;
  font-size: 0.8rem;
  font-weight: 800;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.otc-flow-steps__copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.otc-flow-steps__copy strong {
  font-size: 0.84rem;
  font-weight: 800;
  color: inherit;
}

.otc-flow-steps__copy em {
  font-style: normal;
  font-size: 0.7rem;
  color: #8b93a1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.otc-flow-steps__list li.is-on {
  color: #f5f5f5;
}

.otc-flow-steps__list li.is-on .otc-flow-steps__num {
  border-color: transparent;
  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);
  color: #1b1b1b;
  box-shadow: 0 0 0 4px rgba(213, 167, 96, 0.22), 0 8px 18px rgba(213, 167, 96, 0.28);
  transform: scale(1.04);
}

.otc-flow-steps__list li.is-done {
  color: #e7c98a;
}

.otc-flow-steps__list li.is-done .otc-flow-steps__num {
  border-color: rgba(213, 167, 96, 0.5);
  background: rgba(213, 167, 96, 0.18);
  color: #e7c98a;
}

.otc-flow-steps.is-compact {
  padding: 12px 8px 10px;
  margin-bottom: 14px;
}

.otc-flow-steps.is-compact .otc-flow-steps__track {
  top: 26px;
}

.otc-flow-steps.is-compact .otc-flow-steps__num {
  width: 26px;
  height: 26px;
  font-size: 0.72rem;
}

.otc-flow-steps.is-compact .otc-flow-steps__copy strong {
  font-size: 0.72rem;
}

.otc-desk-flow__panel {
  position: relative;
  border: 1px solid rgba(213, 167, 96, 0.2);
  border-radius: 20px;
  background:
    radial-gradient(ellipse 55% 60% at 100% 0%, rgba(213, 167, 96, 0.1), transparent 50%),
    linear-gradient(165deg, rgba(30, 34, 42, 0.96), rgba(16, 18, 24, 0.94));
  padding: 20px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.32);
  overflow: hidden;
}

.otc-desk-flow__panel::before {
  content: "";
  position: absolute;
  inset: 0 0 auto;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(231, 201, 138, 0.55), transparent);
  pointer-events: none;
}

.otc-desk-flow__panel-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 16px;
}

.otc-desk-flow__eyebrow {
  margin: 0 0 4px;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #d5a760;
}

.otc-desk-flow__panel-title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 800;
  color: #f5f5f5;
}

.otc-desk-flow .otc-trade-kind-tabs {
  display: inline-flex;
  gap: 6px;
  padding: 4px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.28);
}

.otc-desk-flow .otc-trade-kind-tabs button {
  border: 0;
  background: transparent;
  color: #c4c9d2;
  border-radius: 999px;
  padding: 0.45rem 1.05rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease;
}

.otc-desk-flow .otc-trade-kind-tabs button.is-on {
  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);
  color: #1b1b1b;
  box-shadow: 0 6px 14px rgba(213, 167, 96, 0.28);
}

.otc-desk-flow__search {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 46px;
  margin: 0 0 18px;
  padding: 0 14px;
  border-radius: 14px;
  border: 1px solid rgba(213, 167, 96, 0.22);
  background: rgba(0, 0, 0, 0.28);
  color: #d5a760;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.otc-desk-flow__search:focus-within {
  border-color: rgba(213, 167, 96, 0.55);
  box-shadow: 0 0 0 3px rgba(213, 167, 96, 0.12);
}

.otc-desk-flow__search input {
  flex: 1 1;
  min-width: 0;
  border: 0;
  background: transparent;
  color: #f5f5f5;
  font: inherit;
  outline: none;
}

.otc-desk-flow__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(168px, 1fr));
  gap: 14px;
}

.otc-desk-pair {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  min-height: 148px;
  text-align: left;
  padding: 18px 16px 16px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background:
    linear-gradient(160deg, rgba(36, 40, 50, 0.92), rgba(14, 16, 22, 0.95));
  color: #f5f5f5;
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.otc-desk-pair__glow {
  position: absolute;
  top: 0;
  left: 16px;
  right: 16px;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, transparent, rgba(231, 201, 138, 0.75), transparent);
  opacity: 0.55;
  transition: opacity 0.2s ease;
}

.otc-desk-pair:hover,
.otc-desk-pair:focus-visible {
  outline: none;
  border-color: rgba(213, 167, 96, 0.75);
  background:
    radial-gradient(ellipse 90% 70% at 50% 0%, rgba(213, 167, 96, 0.16), transparent 55%),
    linear-gradient(160deg, rgba(42, 38, 30, 0.95), rgba(14, 16, 22, 0.98));
  transform: translateY(-3px);
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(213, 167, 96, 0.12);
}

.otc-desk-pair:hover .otc-desk-pair__glow,
.otc-desk-pair:focus-visible .otc-desk-pair__glow {
  opacity: 1;
}

.otc-desk-pair__symbol {
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: 0.01em;
}

.otc-desk-pair__price {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.otc-desk-pair__price span {
  font-size: 0.68rem;
  font-weight: 700;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.otc-desk-pair__price strong {
  color: #e7c98a;
  font-size: 1.05rem;
  font-variant-numeric: tabular-nums;
}

.otc-desk-pair__cta {
  margin-top: auto;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 0.82rem;
  font-weight: 700;
  color: #d5a760;
  transition: gap 0.18s ease;
}

.otc-desk-pair:hover .otc-desk-pair__cta {
  gap: 6px;
}

.otc-desk-flow__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px 16px;
  color: #9ca3af;
}

.otc-desk-flow__pending {
  margin-top: 20px;
}

.otc-quote-modal-wrap {
  padding: 48px 16px 40px;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.otc-quote-modal {
  width: min(540px, 100%);
  max-height: min(calc(100vh - 96px), 820px);
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 18px 20px 28px;
  border-radius: 22px;
  margin: auto;
  animation: otc-quote-pop 0.22s ease-out;
  scrollbar-gutter: stable;
}

.otc-quote-modal--themed {
  position: relative;
  border: 1px solid rgba(213, 167, 96, 0.32);
  background:
    radial-gradient(ellipse 80% 50% at 80% -10%, rgba(231, 201, 138, 0.18), transparent 50%),
    radial-gradient(ellipse 60% 40% at 0% 100%, rgba(213, 167, 96, 0.1), transparent 45%),
    linear-gradient(180deg, rgba(30, 34, 42, 0.99), rgba(14, 16, 22, 0.99));
  box-shadow:
    0 28px 64px rgba(0, 0, 0, 0.55),
    0 0 40px rgba(213, 167, 96, 0.06),
    0 0 0 1px rgba(255, 255, 255, 0.04) inset;
}

.otc-quote-modal--themed::before {
  content: "";
  position: absolute;
  inset: 0 0 auto;
  height: 2px;
  background: linear-gradient(90deg, transparent 5%, rgba(231, 201, 138, 0.85), transparent 95%);
  pointer-events: none;
}

.otc-quote-modal-wrap .otc-trade-overlay,
.otc-quote-modal-wrap.otc-trade-overlay {
  background: rgba(4, 6, 10, 0.78);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.otc-quote-modal__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 32px;
  margin: 0 0 8px;
}

.otc-quote-modal__top .otc-quote-back {
  gap: 2px;
  font-size: 0.9rem;
}

.otc-quote-modal__top .otc-trade-close {
  position: static;
  top: auto;
  right: auto;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.04);
  color: #d5a760;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.otc-quote-modal__top .otc-trade-close:hover {
  background: rgba(213, 167, 96, 0.12);
  border-color: rgba(213, 167, 96, 0.45);
}

.otc-quote-modal__eyebrow {
  margin: 0 0 4px;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #d5a760;
}

.otc-quote-modal .otc-card-title {
  margin: 0 0 6px;
  padding-right: 0;
  font-size: 1.28rem;
  line-height: 1.25;
  font-weight: 800;
  background: linear-gradient(120deg, #fff 30%, #e7c98a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.otc-quote-modal__hint {
  margin: 0 0 14px;
  color: #9ca3af;
  font-size: 0.84rem;
  line-height: 1.4;
}

.otc-quote-modal .otc-flow-steps {
  margin: 0 0 14px;
  padding: 12px 8px 10px;
}

.otc-quote-modal .otc-flow-steps__track {
  top: 26px;
}

.otc-quote-modal .otc-trade-kind-tabs {
  display: inline-flex;
  gap: 6px;
  margin: 0 0 12px;
  padding: 4px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.28);
}

.otc-quote-modal .otc-trade-kind-tabs button {
  border: 0;
  border-radius: 999px;
  padding: 0.45rem 1.05rem;
}

.otc-quote-modal .otc-trade-kind-tabs button.is-on {
  box-shadow: 0 6px 14px rgba(213, 167, 96, 0.28);
}

.otc-quote-modal .otc-pair-search {
  margin: 0 0 12px;
}

.otc-quote-modal .otc-pair-search .quote-input-card {
  border-radius: 14px;
  height: 46px;
  border-color: rgba(213, 167, 96, 0.22);
  background: rgba(0, 0, 0, 0.3);
}

.otc-quote-modal .otc-pair-search .quote-input-card:focus-within {
  border-color: rgba(213, 167, 96, 0.55);
  box-shadow: 0 0 0 3px rgba(213, 167, 96, 0.12);
}

.otc-quote-modal .otc-active-rail,
.otc-quote-modal .otc-active-rail--quote {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
  margin: 0 0 14px;
  max-height: none;
  overflow: visible;
}

.otc-quote-modal .otc-active-rail button {
  padding: 11px 6px;
  border-radius: 14px;
  gap: 5px;
  border-color: rgba(255, 255, 255, 0.1);
  background: linear-gradient(180deg, rgba(36, 40, 50, 0.9), rgba(12, 14, 18, 0.95));
  transition: border-color 0.18s ease, background 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;
}

.otc-quote-modal .otc-active-rail button:hover {
  border-color: rgba(213, 167, 96, 0.5);
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);
}

.otc-quote-modal .otc-active-rail button.is-on {
  border-color: rgba(213, 167, 96, 0.9);
  background: linear-gradient(180deg, rgba(231, 201, 138, 0.28), rgba(213, 167, 96, 0.12));
  box-shadow: 0 0 0 1px rgba(213, 167, 96, 0.2), 0 8px 18px rgba(213, 167, 96, 0.15);
}

.otc-quote-modal .otc-active-rail button span:first-child {
  font-size: 12px;
}

.otc-quote-modal .otc-active-rail button span:last-child {
  font-size: 11px;
  font-weight: 600;
  opacity: 0.85;
  font-variant-numeric: tabular-nums;
}

.otc-quote-modal .quote-field-group {
  margin-bottom: 12px;
}

.otc-quote-modal .quote-field-header {
  gap: 8px;
  align-items: flex-start;
}

.otc-quote-modal .quote-avail-wrap {
  flex-wrap: wrap;
  justify-content: flex-end;
  max-width: 70%;
}

.otc-quote-modal .quote-amount-card {
  border-radius: 14px;
  height: 52px;
  border-color: rgba(213, 167, 96, 0.2);
  background: rgba(0, 0, 0, 0.32);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.otc-quote-modal .quote-amount-card:focus-within {
  border-color: rgba(213, 167, 96, 0.55);
  box-shadow: 0 0 0 3px rgba(213, 167, 96, 0.12);
}

.otc-quote-modal .otc-coin-label {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  background: rgba(213, 167, 96, 0.14);
  border: 1px solid rgba(213, 167, 96, 0.28);
  color: #e7c98a !important;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.03em;
}

.otc-quote-modal .otc-trade-swap-wrap {
  margin: 0 0 8px;
}

.otc-quote-modal .otc-trade-swap {
  width: 40px;
  height: 40px;
  border-color: rgba(213, 167, 96, 0.4);
  background: linear-gradient(180deg, rgba(40, 36, 28, 0.95), rgba(20, 18, 14, 0.98));
  color: #e7c98a;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.otc-quote-modal .otc-trade-swap:hover {
  transform: rotate(180deg);
  box-shadow: 0 0 0 3px rgba(213, 167, 96, 0.15);
}

.otc-quote-modal__actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  margin-top: 8px;
  padding: 4px 0 12px;
}

.otc-quote-modal__actions .btn-request-quote {
  margin-top: 0;
  border: 0;
  border-radius: 14px;
  min-height: 50px;
  font-weight: 800;
  letter-spacing: 0.02em;
  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);
  color: #1b1b1b;
  box-shadow: 0 12px 26px rgba(213, 167, 96, 0.32);
}

.otc-quote-modal__actions .btn-request-quote:disabled {
  opacity: 0.45;
  box-shadow: none;
}

.otc-quote-modal__actions .btn-request-quote:not(:disabled):hover {
  filter: brightness(1.06);
  transform: translateY(-1px);
}

.otc-quote-modal__actions .otc-trades-link {
  align-self: center;
  color: #d5a760;
  font-weight: 700;
  padding-bottom: 4px;
}

@keyframes otc-quote-pop {
  from { opacity: 0; transform: translateY(10px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.otc-quote-modal__pair {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 16px;
  padding: 14px 16px;
  border-radius: 16px;
  border: 1px solid rgba(213, 167, 96, 0.42);
  background:
    radial-gradient(ellipse 80% 100% at 0% 50%, rgba(231, 201, 138, 0.18), transparent 55%),
    linear-gradient(135deg, rgba(231, 201, 138, 0.14), rgba(213, 167, 96, 0.05));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05), 0 8px 18px rgba(0, 0, 0, 0.18);
}

.otc-quote-modal__pair-main {
  min-width: 0;
}

.otc-quote-modal__pair-label {
  display: block;
  margin-bottom: 2px;
  font-size: 0.72rem;
  font-weight: 700;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.otc-quote-modal__pair strong {
  font-size: 1.05rem;
  line-height: 1.2;
}

.otc-quote-modal__pair-price {
  text-align: right;
}

.otc-quote-modal__pair-price span {
  display: block;
  margin-bottom: 2px;
  font-size: 0.72rem;
  font-weight: 700;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.otc-quote-modal__pair-price strong {
  color: #e7c98a;
  font-variant-numeric: tabular-nums;
  font-size: 1.05rem;
  line-height: 1.2;
}

body.light_theme .otc-desk-flow__lead {
  color: #64748b;
}

body.light_theme .otc-desk-flow .so-page__title {
  background: none;
  background-clip: unset;
  color: #0f172a;
}

body.light_theme .otc-flow-steps,
body.light_theme .otc-desk-flow__panel {
  background: #fff;
  border-color: #e8d7b4;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);
}

body.light_theme .otc-flow-steps__track {
  background: #e2e8f0;
}

body.light_theme .otc-flow-steps__num {
  background: #fff;
}

body.light_theme .otc-desk-flow__panel-title,
body.light_theme .otc-desk-pair {
  color: #0f172a;
}

body.light_theme .otc-desk-pair {
  background: linear-gradient(160deg, #fff, #f8fafc);
  border-color: #e2e8f0;
}

body.light_theme .otc-desk-pair:hover,
body.light_theme .otc-desk-pair:focus-visible {
  background: linear-gradient(160deg, #fffaf0, #fff);
  border-color: #d5a760;
}

body.light_theme .otc-desk-flow .otc-trade-kind-tabs {
  background: #f1f5f9;
  border-color: #e2e8f0;
}

body.light_theme .otc-desk-flow .otc-trade-kind-tabs button {
  color: #475569;
}

body.light_theme .otc-desk-flow__search {
  background: #fff;
  border-color: #e8d7b4;
}

body.light_theme .otc-desk-flow__search input {
  color: #0f172a;
}

body.light_theme .otc-quote-modal--themed {
  background: linear-gradient(180deg, #fff, #fbf7ef);
  border-color: #e8d7b4;
  box-shadow: 0 24px 56px rgba(15, 23, 42, 0.14);
}

body.light_theme .otc-quote-modal .otc-card-title {
  background: none;
  background-clip: unset;
  color: #0f172a;
}

body.light_theme .otc-quote-modal__hint {
  color: #64748b;
}

body.light_theme .otc-quote-modal .otc-coin-label {
  background: #fff8ee;
  border-color: #e8d7b4;
  color: #8a6a2f !important;
}

body.light_theme .otc-quote-modal .quote-amount-card {
  background: #f8fafc;
  border-color: #e8d7b4;
}

@media (max-width: 720px) {
  .otc-flow-steps__list {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .otc-flow-steps__copy em {
    display: none;
  }

  .otc-flow-steps__track {
    top: 28px;
    left: 10%;
    right: 10%;
  }

  .otc-desk-flow__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .otc-desk-flow__panel-head {
    flex-direction: column;
    align-items: stretch;
  }

  .otc-quote-modal-wrap {
    align-items: flex-end;
    padding: 12px 8px calc(12px + env(safe-area-inset-bottom, 0px));
  }

  .otc-quote-modal {
    width: 100%;
    max-height: calc(100vh - 48px - env(safe-area-inset-bottom, 0px));
    border-radius: 16px 16px 12px 12px;
    padding-bottom: 24px;
  }
}

.otc-trade-shell__top {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  margin: 0 0 22px;
}

.otc-trade-shell__title {
  margin: 6px 0 4px;
  font-size: clamp(1.5rem, 2.4vw, 2rem);
  font-weight: 800;
  letter-spacing: 0.02em;
  color: #f5f5f5;
}

.otc-trade-shell__sub {
  margin: 0;
  max-width: 42ch;
  color: #9ca3af;
  font-size: 0.92rem;
  line-height: 1.45;
}

.otc-trade-steps {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.otc-trade-steps li {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(28, 33, 40, 0.9);
  color: #9ca3af;
  font-size: 0.82rem;
  font-weight: 700;
}

.otc-trade-steps li span {
  display: inline-grid;
  place-items: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  color: #d5a760;
  font-size: 0.75rem;
}

.otc-trade-steps li.is-on {
  border-color: rgba(213, 167, 96, 0.55);
  background: linear-gradient(180deg, rgba(231, 201, 138, 0.18), rgba(213, 167, 96, 0.1));
  color: #f5f5f5;
  box-shadow: 0 0 0 1px rgba(213, 167, 96, 0.2);
}

.otc-trade-steps li.is-done {
  border-color: rgba(213, 167, 96, 0.35);
  color: #e7c98a;
}

.otc-trade-steps li.is-done span,
.otc-trade-steps li.is-on span {
  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);
  color: #1b1b1b;
}

.otc-trade-shell__grid {
  display: grid;
  grid-template-columns: minmax(280px, 360px) minmax(0, 1fr);
  gap: 18px;
  align-items: start;
}

.otc-trade-rail {
  background: #1c2128;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 18px;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.28);
  overflow: hidden;
  min-height: 560px;
  display: flex;
  flex-direction: column;
}

.otc-trade-rail__tabs {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: #171b20;
}

.otc-trade-rail__tabs button {
  border: 0;
  background: transparent;
  color: #9ca3af;
  font-weight: 700;
  font-size: 0.82rem;
  padding: 14px 8px;
  cursor: pointer;
}

.otc-trade-rail__tabs button.is-on {
  color: #1b1b1b;
  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);
}

.otc-trade-rail__body {
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1;
  min-height: 0;
  overflow: auto;
}

.otc-trade-rail__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.otc-trade-rail__pair {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  text-align: left;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.03);
  color: #f5f5f5;
  border-radius: 12px;
  padding: 12px 14px;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, transform 0.15s ease;
}

.otc-trade-rail__pair:hover {
  border-color: rgba(213, 167, 96, 0.45);
  background: rgba(213, 167, 96, 0.08);
}

.otc-trade-rail__pair.is-on {
  border-color: rgba(213, 167, 96, 0.7);
  background: linear-gradient(135deg, rgba(231, 201, 138, 0.16), rgba(213, 167, 96, 0.08));
  box-shadow: inset 0 0 0 1px rgba(213, 167, 96, 0.25);
}

.otc-trade-rail__pair strong {
  font-size: 0.95rem;
}

.otc-trade-rail__pair span {
  color: #d5a760;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  font-size: 0.85rem;
}

.otc-trade-rail__filters {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.otc-trade-rail__filters select,
.otc-trade-rail__filters input[type="date"] {
  height: 38px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.04);
  color: #f5f5f5;
  padding: 0 10px;
  font: inherit;
  font-size: 0.8rem;
}

.otc-trade-main {
  min-width: 0;
}

.otc-trade-home-card.otc-trade-main-card {
  width: 100%;
  max-width: none;
  max-height: none;
  margin: 0;
  padding: 22px 24px 28px;
  border-radius: 18px;
  box-sizing: border-box;
}

.otc-trade-main__pair {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 14px;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(213, 167, 96, 0.08);
  border: 1px solid rgba(213, 167, 96, 0.28);
}

.otc-trade-main__pair span {
  font-weight: 800;
  letter-spacing: 0.02em;
}

.otc-trade-main__pair strong {
  color: #e7c98a;
  font-variant-numeric: tabular-nums;
}

body.light_theme .otc-trade-shell {
  background:
    radial-gradient(ellipse 80% 50% at 10% -10%, rgba(213, 167, 96, 0.18), transparent 55%),
    #f4f6f8;
  color: #0f172a;
}

body.light_theme .otc-trade-shell__title {
  color: #0f172a;
}

body.light_theme .otc-trade-shell__sub {
  color: #64748b;
}

body.light_theme .otc-trade-steps li {
  background: #fff;
  border-color: #e2e8f0;
  color: #64748b;
}

body.light_theme .otc-trade-rail {
  background: #fff;
  border-color: #e2e8f0;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
}

body.light_theme .otc-trade-rail__tabs {
  background: #f8fafc;
  border-bottom-color: #e2e8f0;
}

body.light_theme .otc-trade-rail__pair {
  background: #f8fafc;
  border-color: #e2e8f0;
  color: #0f172a;
}

body.light_theme .otc-trade-rail__pair.is-on {
  background: #fff8eb;
  border-color: #d5a760;
}

body.light_theme .otc-trade-rail__filters select,
body.light_theme .otc-trade-rail__filters input[type="date"] {
  background: #fff;
  border-color: #cbd5e1;
  color: #0f172a;
}

@media (max-width: 960px) {
  .otc-trade-shell__grid {
    grid-template-columns: 1fr;
  }

  .otc-trade-rail {
    min-height: 0;
    max-height: 420px;
  }
}

.otc-trade-home-card {
  position: relative;
  width: min(520px, 100%);
  max-height: 92vh;
  overflow: auto;
  background: #1c2128;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
  color: #f5f5f5;
}

.otc-quote-back {
  display: inline-flex;
  align-items: center;
  margin: 0;
  padding: 4px 0;
  border: 0;
  background: transparent;
  color: #d5a760;
  font-weight: 700;
  cursor: pointer;
}

.otc-trade-home-card .otc-card-title {
  padding-right: 42px;
}

body.light_theme .otc-quote-back {
  color: #8a6a2f;
}

.otc-trade-desk .otc-trade-home-card .otc-card-title,
.otc-trade-desk .otc-trade-home-card .quote-live-last,
.otc-trade-desk .otc-trade-home-card .quote-field-input,
.otc-trade-desk .otc-trade-home-card .otc-coin-label {
  color: #f5f5f5;
}

.otc-trade-desk .otc-trade-home-card .quote-field-label,
.otc-trade-desk .otc-trade-home-card .quote-avail-text {
  color: #9ca3af;
}

.otc-trade-desk .otc-trade-home-card .quote-input-card {
  width: 100%;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.16);
  box-shadow: none;
}

.otc-trade-desk .otc-trade-home-card .quote-field-input::placeholder {
  color: #8b93a1;
}

.otc-trade-desk .otc-trade-home-card .otc-trade-kind-tabs button {
  background: transparent;
  color: #f5f5f5;
  border-color: rgba(255, 255, 255, 0.2);
}

.otc-trade-desk .otc-trade-home-card .otc-trade-kind-tabs button.is-on {
  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);
  color: #1b1b1b;
  border-color: transparent;
}

body.light_theme .otc-trade-desk .otc-trade-home.otc-trade-overlay {
  background: rgb(255 255 255 / 46%);
}

body.light_theme .otc-trade-home-card {
  background: rgba(255, 255, 255, 0.50);
  border: 1px solid rgba(255, 255, 255, 0.65);
  box-shadow: 0 10px 30px rgb(0 0 0 / 30%);
  color: #0f172a;
}

body.light_theme .otc-trade-desk .otc-trade-home-card .otc-card-title,
body.light_theme .otc-trade-desk .otc-trade-home-card .quote-live-last,
body.light_theme .otc-trade-desk .otc-trade-home-card .quote-field-input,
body.light_theme .otc-trade-desk .otc-trade-home-card .otc-coin-label {
  color: #0f172a;
}

body.light_theme .otc-trade-desk .otc-trade-home-card .quote-field-label,
body.light_theme .otc-trade-desk .otc-trade-home-card .quote-avail-text {
  color: #64748b;
}

body.light_theme .otc-trade-desk .otc-trade-home-card .quote-input-card {
  background: #f4f6f8;
  border-color: #e5e7eb;
  box-shadow: none;
}

body.light_theme .otc-trade-desk .otc-trade-home-card .quote-field-input::placeholder {
  color: #94a3b8;
}

body.light_theme .otc-trade-desk .otc-trade-home-card .otc-trade-kind-tabs button {
  background: #ffffff;
  color: #334155;
  border-color: #d7deea;
}

body.light_theme .otc-trade-desk .otc-trade-home-card .otc-trade-kind-tabs button.is-on {
  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);
  color: #1b1b1b;
  border-color: transparent;
}

body.light_theme .otc-trade-desk .otc-trade-swap {
  background: #ffffff;
  border-color: #e5e7eb;
}

body.light_theme .otc-pair-search-list {
  background: #ffffff;
  border-color: #e5e7eb;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
}

body.light_theme .otc-pair-search-list button {
  color: #0f172a;
}

body.light_theme .otc-pair-search-empty {
  color: #64748b;
}

.otc-trade-desk .otc-suite-header {
  margin-bottom: 16px;
}

.otc-exchange-tabs {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin: 0 0 28px;
}

.otc-exchange-tabs button {
  border: 1px solid rgba(213, 167, 96, 0.45);
  background: transparent;
  color: #f5f5f5;
  border-radius: 999px;
  padding: 10px 22px;
  font-weight: 700;
  cursor: pointer;
}

.otc-exchange-tabs button.is-on {
  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);
  color: #1b1b1b;
  border-color: transparent;
}

body.light_theme .otc-exchange-tabs button {
  color: #1b1b1b;
}

.otc-trade-desk .otc-rfq-card .quote-field-input {
  width: auto;
  height: auto;
  border: 0;
  border-radius: 0;
  background: transparent;
  padding: 0;
  box-shadow: none;
}

.otc-trade-desk .otc-trade-kind-tabs {
  justify-content: flex-start;
  margin: 0 0 24px;
}

.otc-trade-desk .otc-pair-search {
  position: relative;
  width: 100%;
  height: auto;
  margin: 0 0 14px;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  z-index: 4;
}

.otc-trade-desk .otc-pair-search .quote-input-card {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 48px;
  margin: 0;
  padding: 0 16px;
  border-radius: 50px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.22);
  box-shadow: none;
  box-sizing: border-box;
}

.otc-trade-desk .otc-pair-search .quote-input-card:focus-within {
  border-color: #d5a760;
}

body.light_theme .otc-trade-desk .otc-pair-search {
  width: 100%;
  height: auto;
  background: transparent;
  border: 0;
}

body.light_theme .otc-trade-desk .otc-pair-search .quote-input-card {
  background: #f4f6f8;
  border-color: #d7deea;
}

.otc-trade-desk .otc-rfq-card .otc-pair-search .quote-field-input {
  flex: 1 1;
  width: 100%;
  min-width: 0;
}

.otc-trade-desk .otc-pair-search .ri-search-line {
  color: #9ca3af;
  font-size: 18px;
}

.otc-pair-search-list {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% + 6px);
  z-index: 6;
  margin: 0;
  padding: 6px;
  list-style: none;
  background: #171b20;
  border: 1px solid #686868;
  border-radius: 16px;
  max-height: 240px;
  overflow: auto;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.35);
}

.otc-pair-search-list button {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  border: 0;
  background: transparent;
  color: #fff;
  border-radius: 10px;
  padding: 10px 12px;
  cursor: pointer;
  font-weight: 700;
}

.otc-pair-search-list button.is-on,
.otc-pair-search-list button:hover {
  background: rgba(213, 167, 96, 0.16);
}

.otc-pair-search-empty {
  padding: 10px 12px;
  color: #9ca3af;
}

.otc-trade-desk .otc-active-rail {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 6px;
  margin: 0 0 14px;
}

.otc-trade-desk .otc-active-rail button {
  min-width: 0;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.06);
  color: #f5f5f5;
  border-radius: 12px;
  padding: 8px 4px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.otc-trade-desk .otc-active-rail button span {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 700;
}

.otc-trade-desk .otc-active-rail button.is-on {
  border-color: #d5a760;
  background: rgba(213, 167, 96, 0.2);
}

body.light_theme .otc-trade-desk .otc-active-rail button {
  background: #f4f6f8;
  border-color: #d7deea;
  color: #0f172a;
}

body.light_theme .otc-trade-desk .otc-active-rail button.is-on {
  border-color: #d5a760;
  background: #fff8ee;
}

.otc-trade-desk .otc-rfq-card .quote-pair-price-row.quote-input-card {
  padding-right: 16px;
}

.otc-trade-desk .otc-rfq-card .otc-coin-label {
  color: #fff;
  font-weight: 700;
}

.otc-trades-link {
  display: block;
  width: 100%;
  margin-top: 12px;
  border: 0;
  background: transparent;
  color: #d5a760;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
}

.otc-trades-screen {
  width: min(640px, 100%);
}

.otc-trades-screen .otc-trade-kind-tabs {
  margin-top: 14px;
}

.otc-my-trades {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
}

.otc-my-trade {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.04);
}

.otc-my-trade strong {
  display: block;
  font-size: 14px;
}

.otc-my-trade span {
  color: #9ca3af;
  font-size: 12px;
}

.otc-my-trade p {
  margin: 8px 0;
}

.otc-my-trade-actions {
  display: flex;
  gap: 8px;
  margin-top: 18px;
}

.otc-my-trade-actions button {
  border: 1px solid rgba(213, 167, 96, 0.5);
  background: transparent;
  color: #e7c98a;
  border-radius: 999px;
  padding: 4px 20px;
  font-weight: 500;
  cursor: pointer;
  font-size: 13px;
}

body.light_theme .otc-my-trade {
  background: #f8fafc;
  border-color: #e5e7eb;
  color: #0f172a;
}

body.light_theme .otc-my-trade span {
  color: #64748b;
}

body.light_theme .otc-my-trade-actions button {
  color: #8a6a2f;
  background: #fff;
}

body.light_theme .otc-status-chip {
  color: #8a6a2f;
}

body.light_theme .otc-status-chip.is-done {
  color: #0f7a4a;
}

body.light_theme .otc-status-chip.is-bad {
  color: #b42318;
}

.otc-open-requests {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  margin-top: 12px;
}

body.light_theme .otc-trade-overlay {
  background-color: rgb(255 255 255 / 60%);
}

.otc-open-requests button {
  flex: 0 0 auto;
  border: 0;
  background: transparent;
  color: #d5a760;
  cursor: pointer;
  font-weight: 700;
}

.otc-trade-swap-wrap {
  display: flex;
  justify-content: center;
  padding-top: 4px;
  margin: 0px 0 8px;
  position: relative;
  z-index: 2;
}

.otc-trade-swap {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #686868;
  background: #1c2128;
  color: #d5a760;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.otc-trade-desk .btn-request-quote,
.otc-trade-form-popup .btn-request-quote {
  width: 100%;
  margin-top: 8px;
  position: relative;
  z-index: 2;
}

.otc-trade-desk .otc-trade-list {
  margin-top: 0;
}

.otc-trade-panel {
  max-width: 760px;
  margin: 32px auto;
  padding: 24px;
  border: 1px solid rgba(213, 167, 96, 0.35);
  border-radius: 16px;
  background: #12151b;
  color: #f5f5f5;
}

body.light_theme .otc-trade-panel {
  background: #fff;
  color: #1b1b1b;
}

.otc-trade-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

.otc-trade-row label,
.otc-trade-field span {
  display: block;
  font-size: 12px;
  opacity: 0.75;
  margin-bottom: 6px;
}

.otc-trade-field {
  flex: 1 1;
  min-width: 180px;
}

.otc-trade-panel input,
.otc-trade-panel select {
  width: 100%;
  border-radius: 10px;
  border: 1px solid rgba(213, 167, 96, 0.4);
  background: transparent;
  color: inherit;
  padding: 10px 12px;
}

.otc-trade-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.otc-trade-swap {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 1px solid #d5a760;
  background: transparent;
  color: #d5a760;
  cursor: pointer;
}

.otc-trade-note {
  font-size: 13px;
  margin: 8px 0;
}

.otc-trade-error {
  color: #ff8d8d;
}

.otc-trade-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999999999;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

/* Keep orders sidebar visible and clickable while OTC popups are open */
@media (min-width: 992px) {
  .otc-trade-overlay.otc-trade-overlay--aside-safe {
    left: 324px;
    z-index: 90;
  }

  body:has(.dashboard--sidebar-collapsed) .otc-trade-overlay.otc-trade-overlay--aside-safe {
    left: 76px;
  }

  body:has(.otc-trade-overlay--aside-safe) .profile-sidebar-shell.leftside_menu {
    position: relative;
    z-index: 120;
  }
}

.otc-trade-overlay .otc-card-title {
  font-size: 22px;
}

.otc-trade-overlay .otc-exchange-tabs button {
  padding: 6px 22px;
  font-weight: 500;
  font-size: 14px;
}

.otc-trade-overlay .otc-quote-back {
  font-weight: 400;
  font-size: 13px;
}

.otc-trade-overlay .otc-trade-home-card {
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  background: rgb(26 26 26 / 20%);
  border-radius: 22px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: inset 0 1px 0 rgb(0 0 0 / 50%), 0 28px 64px rgba(0, 0, 0, 0.48);
}

.otc-trade-popup {
  position: relative;
  width: min(520px, 100%);
  min-height: 300px;
  max-height: 90vh;
  overflow: auto;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  color: #fff;
  padding: 24px;
  background: rgb(26 26 26 / 20%);
  border-radius: 22px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: inset 0 1px 0 rgb(0 0 0 / 50%), 0 28px 64px rgba(0, 0, 0, 0.48);

}

.otc-trade-popup .otc-exchange-tabs.otc-trade-kind-tabs {
  justify-content: start;
}

.otc-trade-popup.otc-trade-home-card {
  /* border-radius: 20px;
  padding: 24px;
  background: #1c2128;
  border: 1px solid rgba(255, 255, 255, 0.12); */
  color: #f5f5f5;
}

body.light_theme .otc-trade-popup.otc-trade-home-card {
  /* background: #ffffff;
  border-color: #e6e8ee; */
  color: #0f172a;
}

.otc-trade-popup.otc-trade-home-card .otc-card-title {
  margin-bottom: 8px;
}

.otc-trade-popup.otc-trade-home-card .otc-trade-lead {
  margin-bottom: 16px;
}

.otc-trade-popup h2 {
  margin: 0 0 6px;
  font-size: 22px;
  line-height: 1.25;
  padding-right: 40px;
}

.otc-trade-lead {
  margin: 0;
  color: #9ca3af;
  font-size: 14px;
}

.otc-trade-amounts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin: 16px 0 4px;
}

.otc-trade-amounts div {
  border: 1px solid rgba(213, 167, 96, 0.35);
  border-radius: 12px;
  padding: 12px 14px;
  background: rgba(213, 167, 96, 0.08);
}

.otc-trade-amounts span {
  display: block;
  font-size: 12px;
  color: #9ca3af;
  margin-bottom: 4px;
}

.otc-trade-amounts strong {
  display: block;
  font-size: 16px;
  line-height: 1.3;
  word-break: break-word;
}

.otc-trade-footer-one {
  grid-template-columns: 1fr;
}

.otc-trade-footer {
  display: grid;
  grid-template-columns: 1fr 1.35fr;
  gap: 12px;
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid rgba(213, 167, 96, 0.28);
}

.otc-trade-footer button {
  height: 44px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.otc-trade-back {
  background: transparent;
  color: #f5f5f5;
  border: 1px solid rgba(255, 255, 255, 0.22);
}

.otc-trade-back:hover:not(:disabled) {
  border-color: #d5a760;
  color: #e7c98a;
}

.otc-trade-confirm {
  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);
  color: #1b1b1b;
  border: none;
}

.otc-trade-confirm:hover:not(:disabled) {
  filter: brightness(1.05);
}

.otc-trade-footer button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.otc-trade-close {
  position: absolute;
  top: 14px;
  right: 14px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: inherit;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
}

body.light_theme .otc-trade-popup {
  background: rgba(255, 255, 255, 0.20);
  border: 1px solid rgba(255, 255, 255, 0.65);
  box-shadow: 0 10px 30px rgb(0 0 0 / 15%);
  color: #1b1b1b;
}

body.light_theme .otc-trade-lead,
body.light_theme .otc-trade-amounts span {
  color: #64748b;
}

body.light_theme .otc-trade-amounts div {
  background: #fbf7ef;
}

body.light_theme .otc-trade-back {
  color: #1b1b1b;
  border-color: #d7deea;
  background: #fff;
}

.otc-trade-popup dl {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 10px 16px;
  margin: 16px 0;
}

.otc-trade-popup dt,
.otc-trade-popup dd {
  margin: 0;
}

.otc-trade-popup dt {
  opacity: 0.7;
}

.otc-trade-popup dd {
  font-weight: 600;
  word-break: break-word;
}

.otc-trade-detail {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 12px;
  font-size: 13px;
}

.otc-trade-detail span {
  opacity: 0.75;
}

.otc-trade-detail input,
.otc-trade-detail select {
  width: 100%;
  height: 42px;
  border-radius: 10px;
  border: 1px solid rgba(213, 167, 96, 0.55);
  background: transparent;
  color: inherit;
  padding: 0 12px;
}

.otc-trade-detail input::placeholder {
  color: #9ca3af;
  opacity: 1;
}

.otc-trade-detail input[readonly] {
  cursor: default;
  background: rgba(255, 255, 255, 0.04);
}

.otc-receive-choice {
  border: 1px solid rgba(213, 167, 96, 0.35);
  border-radius: 10px;
  padding: 12px;
  margin: 0;
}

.otc-receive-choice legend {
  padding: 0 4px;
  opacity: 0.75;
  font-size: 13px;
}

.otc-receive-choice__option {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  font-size: 14px;
  cursor: pointer;
}

.otc-receive-choice__option input {
  width: auto;
  height: auto;
  margin: 0;
}

.otc-request-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}

.otc-request-head .otc-card-title {
  margin-bottom: 4px;
}

.otc-history-btn,
.otc-request-action {
  height: 34px;
  padding: 0 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.otc-history-btn {
  border: 1px solid rgba(213, 167, 96, 0.7);
  background: transparent;
  color: #e7c98a;
}

.otc-request-action {
  border: none;
  background: #d1aa67;
  color: #1b1b1b;
}

.otc-request-list {
  margin-top: 8px;
}

.otc-request-row {
  display: grid;
  grid-template-columns: minmax(140px, 1.2fr) minmax(90px, 0.8fr) minmax(120px, 1fr) minmax(130px, 1.1fr) minmax(140px, 1.1fr) 200px;
  min-width: 900px;
  align-items: center;
  gap: 10px;
  min-height: 52px;
  padding: 8px 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 13px;
}

.otc-request-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

.otc-history-row {
  grid-template-columns: minmax(140px, 1.15fr) minmax(90px, 0.7fr) minmax(90px, 0.7fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(110px, 0.9fr) 72px;
  min-width: 900px;
}

.otc-history-back {
  margin: 0 0 10px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #e7c98a;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.otc-history-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  margin: 8px 0 14px;
}

.otc-history-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #9ca3af;
  font-size: 12px;
  font-weight: 700;
}

.otc-history-date {
  height: 42px;
  min-width: 150px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(0, 0, 0, 0.25);
  color: #fff;
  color-scheme: dark;
  padding: 0 12px;
  font-size: 14px;
}

body.light_theme .otc-history-date {
  background: #fff;
  color: #0f172a;
  border-color: #e2e8f0;
  color-scheme: light;
}

body.light_theme .otc-history-back,
body.light_theme .otc-history-field {
  color: #8a6a2f;
}

body.light_theme .otc-history-field {
  color: #64748b;
}

.otc-history-page .otc-request-list {
  flex: 1 1;
  max-height: none;
}

.otc-trade-desk.is-history {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.otc-trade-desk.is-history .otc-trading-suite-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding-bottom: 16px;
}

.otc-trade-desk.is-history .otc-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.otc-trade-desk.is-history .otc-history-page {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
}

.otc-request-head-row {
  min-height: 36px;
  color: #9ca3af;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.otc-request-head-row>span:last-child {
  text-align: right;
}

.otc-status-chip {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 4px 10px;
  background: rgb(209 170 103 / 16%);
  color: #e7c98a;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.otc-status-chip.is-live {
  background: rgb(209 170 103 / 24%);
  color: #f3d7a1;
}

.otc-status-chip.is-done {
  background: rgba(43, 194, 135, 0.16);
  color: #7dcea0;
}

.otc-status-chip.is-bad {
  background: rgba(255, 107, 107, 0.14);
  color: #ff9b9b;
}

.otc-history-status {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.otc-history-reason {
  color: #9ca3af;
  font-size: 12px;
  line-height: 1.35;
}

.otc-trade-history-popup {
  width: min(920px, 100%);
}

.otc-trade-list {
  margin-top: 18px;
}

.otc-trade-list table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.otc-trade-list th,
.otc-trade-list td {
  text-align: left;
  padding: 8px 6px;
  border-bottom: 1px solid rgba(213, 167, 96, 0.25);
}

.otc-trade-form-popup {
  width: min(640px, 100%);
}

.otc-trade-form-popup .otc-exchange-tabs {
  justify-content: flex-start;
  margin: 14px 0 16px;
}

.otc-trade-form-popup .quote-pair-price-row {
  display: flex;
  align-items: flex-end;
  gap: 16px;
}

.otc-trade-form-popup .otc-trade-field {
  flex: 1 1;
}

.otc-trade-desk .otc-container {
  width: 100%;
  max-width: none;
  padding: 0 28px;
  box-sizing: border-box;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.otc-desk-layout {
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 18px;
  align-items: stretch;
  flex: 1 1;
}

.otc-desk-nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgb(255 255 255 / 10%);
  box-shadow: inset 0 4px 20px rgba(0, 0, 0, 0.3);
}

.otc-desk-nav button {
  height: 44px;
  border-radius: 999px;
  border: 1px solid rgba(213, 167, 96, 0.45);
  background: transparent;
  color: #f5f5f5;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
  text-align: left;
  padding: 0 16px;
}

.otc-desk-nav button.is-on {
  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);
  color: #1b1b1b;
  border-color: transparent;
}

.otc-desk-main {
  min-width: 0;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.otc-desk-main>.otc-pair-board,
.otc-desk-main>.otc-trade-list {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.otc-desk-main>.otc-pair-works {
  flex: 0 0 auto;
}

body.light_theme .otc-desk-nav {
  background: rgb(0 0 0 / 5%);
  border-color: #eff4fb;
  box-shadow: inset 0 10px 30px rgba(0, 0, 0, 0.07);
}

body.light_theme .otc-desk-nav button {
  color: #1b1b1b;
}

.otc-pair-intro {
  margin: 10px auto 0;
  max-width: 640px;
  color: #9ca3af;
  font-size: 16px;
}

.otc-pair-filters {
  justify-content: flex-end;
  margin: 0;
  flex-wrap: wrap;
}

.otc-pair-filters button {
  padding: 8px 16px;
}

.otc-trade-notice {
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: min(520px, calc(100vw - 32px));
  padding: 12px 12px 12px 16px;
  border-radius: 12px;
  border: 1px solid rgba(213, 167, 96, 0.45);
  background: #1c2128;
  color: #f5f5f5;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
  font-size: 14px;
  line-height: 1.4;
}

.otc-trade-notice button {
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #e7c98a;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

.otc-pair-board {
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  background: rgb(255 255 255 / 10%);
  box-shadow: inset 0 4px 20px rgba(0, 0, 0, 0.3);
  padding: 22px 22px 8px;
}

.otc-pair-toolbar {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 8px;
}

.otc-pair-toolbar .otc-card-title {
  margin-bottom: 4px;
}

.otc-pair-count {
  margin: 0;
  color: #9ca3af;
  font-size: 13px;
}

.otc-pair-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.otc-pair-search {
  width: 220px;
  height: 42px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(0, 0, 0, 0.25);
  color: #fff;
  padding: 0 16px;
  font-size: 14px;
}

.otc-pair-search:focus {
  outline: none;
  border-color: #d5a760;
}

.otc-pair-list,
.otc-trade-desk .otc-request-list {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  overflow: auto;
  margin: 0 -6px;
}

.otc-pair-row {
  display: grid;
  grid-template-columns: minmax(120px, 1.1fr) minmax(160px, 1.5fr) minmax(110px, 0.8fr) minmax(140px, 1fr) 92px;
  min-width: 720px;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 64px;
  padding: 10px 12px;
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: transparent;
  color: #fff;
  text-align: left;
  font: inherit;
  cursor: pointer;
}

.otc-pair-row-head {
  position: sticky;
  top: 0;
  z-index: 1;
  min-height: 40px;
  cursor: default;
  color: #9ca3af;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: #1a1e24;
}

.otc-pair-row:not(.otc-pair-row-head):hover {
  background: rgba(209, 170, 103, 0.1);
}

.otc-pair-symbol {
  font-size: 16px;
  font-weight: 700;
}

.otc-pair-badge {
  display: inline-flex;
  border-radius: 999px;
  padding: 4px 10px;
  background: rgb(209 170 103 / 20%);
  color: #d1aa67;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.otc-pair-price {
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-weight: 700;
  color: #e7c98a;
  line-height: 1.2;
}

.otc-pair-unit,
.otc-pair-path {
  color: #9ca3af;
  font-size: 13px;
  font-weight: 500;
}

.otc-pair-cta {
  justify-self: end;
  min-width: 78px;
  height: 34px;
  padding: 0 14px;
  border-radius: 999px;
  background: #d1aa67;
  color: #1b1b1b;
  font-size: 13px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.otc-pair-works {
  margin-top: 16px;
}

.otc-pair-steps {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
}

.otc-pair-popup-price {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin: 14px 0 8px;
}

.otc-pair-popup-price .quote-live-last {
  font-size: 28px;
  color: #e7c98a;
}

body.light_theme .otc-pair-intro,
body.light_theme .otc-pair-unit,
body.light_theme .otc-pair-path,
body.light_theme .otc-pair-count {
  color: #64748b;
}

body.light_theme .otc-pair-board {
  background: rgb(0 0 0 / 5%);
  border-color: #eff4fb;
  box-shadow: inset 0 10px 30px rgba(0, 0, 0, 0.07);
}

body.light_theme .otc-pair-search {
  background: #fff;
  color: #0f172a;
  border-color: #e2e8f0;
}

body.light_theme .otc-pair-row {
  color: #0f172a;
  border-bottom-color: #eef2f7;
}

body.light_theme .otc-pair-row-head {
  background: #f8fafc;
  color: #64748b;
}

body.light_theme .otc-pair-symbol {
  color: #0f172a;
}

body.light_theme .otc-history-btn {
  color: #8a6a2f;
}

body.light_theme .otc-request-row {
  border-bottom-color: #eef2f7;
}

body.light_theme .otc-request-head-row {
  color: #64748b;
}

@media (max-width: 900px) {

  html:has(.otc-trade-desk),
  body:has(.otc-trade-desk) {
    overflow: auto;
  }

  .otc-trade-desk.otc-desk-page {
    height: auto;
    max-height: none;
    min-height: calc(100vh - 70px);
    overflow: visible;
  }

  .otc-pair-list,
  .otc-trade-desk .otc-request-list {
    max-height: 70vh;
  }

  .otc-desk-layout {
    grid-template-columns: 1fr;
  }

  .otc-desk-nav {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .otc-desk-nav button {
    flex: 1 1;
    text-align: center;
  }

  .otc-pair-toolbar,
  .otc-pair-toolbar-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .otc-pair-filters,
  .otc-pair-search {
    width: 100%;
    justify-content: flex-start;
  }

  .otc-pair-steps {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 700px) {

  .otc-trade-amounts,
  .otc-trade-footer,
  .otc-pair-steps {
    grid-template-columns: 1fr;
  }
}

.otc-history-page {
  min-height: calc(100vh - 70px);
  background: #12151b;
  color: #f5f5f5;
  padding: 32px 20px 64px;
}

.otc-history-wrap {
  width: min(1180px, 100%);
  margin: 0 auto;
}

.otc-history-page h1 {
  margin: 12px 0 6px;
  font-size: 28px;
}

.otc-history-lead {
  margin: 0 0 20px;
  color: #9ca3af;
}

.otc-history-back {
  display: inline-flex;
  color: #d5a760;
  font-weight: 700;
  text-decoration: none;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
}

.otc-history-table {
  overflow-x: auto;
}

.otc-history-table .trades-table td button {
  border: 1px solid rgba(213, 167, 96, 0.5);
  background: transparent;
  color: #e7c98a;
  border-radius: 999px;
  padding: 6px 14px;
  font-weight: 700;
  cursor: pointer;
}

.otc-history-table tr.is-open td {
  background: rgba(213, 167, 96, 0.08);
}

.otc-history-detail {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 16px;
  background: #1c2128;
  padding: 16px 18px;
}

.otc-history-detail h2 {
  display: block;
  margin: 12px 0 0;
}

.otc-history-detail p {
  color: #9ca3af;
  font-size: 13px;
}

.otc-history-detail {
  margin-top: 8px;
}

.otc-history-detail dl {
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 10px 16px;
  margin: 16px 0 0;
}

.otc-history-detail dt {
  color: #9ca3af;
}

.otc-history-detail dd {
  margin: 0;
}

.otc-history-empty {
  color: #9ca3af;
}

body.light_theme .otc-history-page {
  background: #f8fafc;
  color: #0f172a;
}

body.light_theme .otc-history-detail {
  background: #fff;
  border-color: #e5e7eb;
  color: #0f172a;
}

body.light_theme .otc-history-lead,
body.light_theme .otc-history-detail p,
body.light_theme .otc-history-detail dt,
body.light_theme .otc-history-empty {
  color: #64748b;
}

body.light_theme .otc-history-table .trades-table td button {
  color: #8a6a2f;
  background: #fff;
}

body.light_theme .otc-history-table tr.is-open td {
  background: #fff8ee;
}

@media (max-width: 767px) {

  .otc-trade-overlay {
    align-items: end;
  }

  .otc-trade-popup {
    padding: 18px;
    border-radius: 20px 20px 0px 0px;
  }

  .otc-history-detail dl {
    grid-template-columns: 1fr;
  }

  .otc-trade-overlay .otc-trade-home-card {
    border-radius: 18px 18px 0px 0px;
  }

  .otc-trade-desk .otc-rfq-card .otc-coin-label {
    font-size: 12px;
  }

  .otc-trade-close {
    padding: 0px;
  }

  .otc-trade-popup h2 {
    font-size: 18px;
  }

  .otc-trade-lead {
    font-size: 13px;
  }

  .otc-trade-overlay .otc-card-title {
    font-size: 18px;
  }

  .otc-trade-overlay .otc-exchange-tabs button {
    padding: 5px 20px;
    font-size: 13px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/OtcTrade/otc-trade.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;AAChC;;AAEA;EACE;;;WAGS;EACT,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0DAA0D;EAC1D,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C;;2EAEyE;EACzE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;EACpD,8CAA8C;EAC9C,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,MAAM;EACN,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,cAAc;EACd,mFAAmF;EACnF,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB;;2EAEyE;EACzE,aAAa;EACb,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,uFAAuF;EACvF,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,+BAA+B;EAC/B,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C;2EACyE;EACzE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mGAAmG;AACrG;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,uFAAuF;EACvF,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,sCAAsC;EACtC;;2EAEyE;EACzE,2BAA2B;EAC3B,+EAA+E;AACjF;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C;;;2EAGyE;EACzE;;;6CAG2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,8FAA8F;EAC9F,oBAAoB;AACtB;;AAEA;;EAEE,gCAAgC;EAChC,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,2DAA2D;EAC3D,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;EACtC,kFAAkF;EAClF,uGAAuG;AACzG;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,wFAAwF;EACxF,kFAAkF;AACpF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,mDAAmD;AACrD;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oCAAoC;EACpC,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mFAAmF;EACnF,cAAc;EACd,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,6DAA6D;EAC7D,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C;;gFAE8E;EAC9E,mFAAmF;AACrF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAEhB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kDAAkD;EAClD,qBAAqB;AACvB;;AAEA;;EAEE,kDAAkD;EAClD,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kDAAkD;EAClD,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAEhB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,+DAA+D;EACjE;;EAEA;IACE,WAAW;IACX,iEAAiE;IACjE,kCAAkC;IAClC,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,iCAAiC;EACjC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,uFAAuF;EACvF,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;;EAEE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,MAAM;EACN,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;EACrC,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,wFAAwF;EACxF,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE;;WAES;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,2CAA2C;EAC3C,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,qCAAqC;EACrC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,wCAAwC;EACxC,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;EACpC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,wEAAwE;AACxE;EACE;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,mBAAmB;EACnB,2CAA2C;EAC3C,2EAA2E;AAC7E;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,2CAA2C;EAC3C,2EAA2E;;AAE7E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;;;gDAG8C;EAC9C,cAAc;AAChB;;AAEA;EACE;0BACwB;EACxB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,wCAAwC;EACxC,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kIAAkI;EAClI,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,oJAAoJ;EACpJ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,oBAAoB;EACpB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,0CAA0C;EAC1C,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yCAAyC;EACzC,4BAA4B;EAC5B,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kCAAkC;EAClC,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,2CAA2C;EAC3C,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6GAA6G;EAC7G,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,kDAAkD;EAClD,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE;;IAEE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,kBAAkB;EACpB;;EAEA;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;;EAEE;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;AAEF","sourcesContent":[".otc-trade-desk.otc-desk-page {\n  min-height: calc(100vh - 70px);\n}\n\n.otc-trade-shell {\n  background:\n    radial-gradient(ellipse 80% 50% at 10% -10%, rgba(213, 167, 96, 0.14), transparent 55%),\n    radial-gradient(ellipse 60% 40% at 90% 0%, rgba(209, 170, 103, 0.08), transparent 50%),\n    #12151b;\n  color: #f5f5f5;\n  padding: 24px 20px 48px;\n}\n\n.otc-trade-shell--orders {\n  background: transparent;\n  padding: 0;\n  min-height: 0;\n}\n\n.otc-trade-shell__inner {\n  width: min(1180px, 100%);\n  margin: 0 auto;\n}\n\n.otc-trade-shell--orders .otc-trade-shell__inner {\n  width: 100%;\n  max-width: none;\n  margin: 0;\n}\n\n.otc-desk-flow {\n  position: relative;\n}\n\n.otc-desk-flow__hero {\n  position: relative;\n  margin: 0 0 22px;\n  padding: 4px 0 2px;\n}\n\n.otc-desk-flow__kicker {\n  margin: 0 0 8px;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #d5a760;\n}\n\n.otc-desk-flow .so-page__title {\n  margin: 0 0 8px;\n  background: linear-gradient(120deg, #fff 20%, #e7c98a 85%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.otc-desk-flow__lead {\n  margin: 0;\n  max-width: 62ch;\n  color: #9ca3af;\n  font-size: 0.92rem;\n  line-height: 1.45;\n}\n\n.otc-flow-steps {\n  position: relative;\n  margin: 0 0 22px;\n  padding: 20px 14px 16px;\n  border-radius: 18px;\n  border: 1px solid rgba(213, 167, 96, 0.22);\n  background:\n    radial-gradient(ellipse 70% 80% at 10% 0%, rgba(213, 167, 96, 0.12), transparent 55%),\n    linear-gradient(180deg, rgba(28, 32, 40, 0.98), rgba(18, 21, 27, 0.96));\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);\n}\n\n.otc-flow-steps__track {\n  position: absolute;\n  top: 34px;\n  left: 12.5%;\n  right: 12.5%;\n  height: 3px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.1);\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.otc-flow-steps__track-fill {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #d5a760, #e7c98a);\n  box-shadow: 0 0 12px rgba(231, 201, 138, 0.45);\n  transition: width 0.28s ease;\n}\n\n.otc-flow-steps__list {\n  position: relative;\n  z-index: 1;\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 0;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.otc-flow-steps__list li {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  text-align: center;\n  color: #9ca3af;\n  min-width: 0;\n  padding: 0 4px;\n}\n\n.otc-flow-steps__num {\n  display: inline-grid;\n  place-items: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background: #12151b;\n  color: #d5a760;\n  font-size: 0.8rem;\n  font-weight: 800;\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.otc-flow-steps__copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.otc-flow-steps__copy strong {\n  font-size: 0.84rem;\n  font-weight: 800;\n  color: inherit;\n}\n\n.otc-flow-steps__copy em {\n  font-style: normal;\n  font-size: 0.7rem;\n  color: #8b93a1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.otc-flow-steps__list li.is-on {\n  color: #f5f5f5;\n}\n\n.otc-flow-steps__list li.is-on .otc-flow-steps__num {\n  border-color: transparent;\n  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);\n  color: #1b1b1b;\n  box-shadow: 0 0 0 4px rgba(213, 167, 96, 0.22), 0 8px 18px rgba(213, 167, 96, 0.28);\n  transform: scale(1.04);\n}\n\n.otc-flow-steps__list li.is-done {\n  color: #e7c98a;\n}\n\n.otc-flow-steps__list li.is-done .otc-flow-steps__num {\n  border-color: rgba(213, 167, 96, 0.5);\n  background: rgba(213, 167, 96, 0.18);\n  color: #e7c98a;\n}\n\n.otc-flow-steps.is-compact {\n  padding: 12px 8px 10px;\n  margin-bottom: 14px;\n}\n\n.otc-flow-steps.is-compact .otc-flow-steps__track {\n  top: 26px;\n}\n\n.otc-flow-steps.is-compact .otc-flow-steps__num {\n  width: 26px;\n  height: 26px;\n  font-size: 0.72rem;\n}\n\n.otc-flow-steps.is-compact .otc-flow-steps__copy strong {\n  font-size: 0.72rem;\n}\n\n.otc-desk-flow__panel {\n  position: relative;\n  border: 1px solid rgba(213, 167, 96, 0.2);\n  border-radius: 20px;\n  background:\n    radial-gradient(ellipse 55% 60% at 100% 0%, rgba(213, 167, 96, 0.1), transparent 50%),\n    linear-gradient(165deg, rgba(30, 34, 42, 0.96), rgba(16, 18, 24, 0.94));\n  padding: 20px;\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.32);\n  overflow: hidden;\n}\n\n.otc-desk-flow__panel::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 0 auto;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(231, 201, 138, 0.55), transparent);\n  pointer-events: none;\n}\n\n.otc-desk-flow__panel-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 0 0 16px;\n}\n\n.otc-desk-flow__eyebrow {\n  margin: 0 0 4px;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #d5a760;\n}\n\n.otc-desk-flow__panel-title {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 800;\n  color: #f5f5f5;\n}\n\n.otc-desk-flow .otc-trade-kind-tabs {\n  display: inline-flex;\n  gap: 6px;\n  padding: 4px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(0, 0, 0, 0.28);\n}\n\n.otc-desk-flow .otc-trade-kind-tabs button {\n  border: 0;\n  background: transparent;\n  color: #c4c9d2;\n  border-radius: 999px;\n  padding: 0.45rem 1.05rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.18s ease, color 0.18s ease;\n}\n\n.otc-desk-flow .otc-trade-kind-tabs button.is-on {\n  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);\n  color: #1b1b1b;\n  box-shadow: 0 6px 14px rgba(213, 167, 96, 0.28);\n}\n\n.otc-desk-flow__search {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 46px;\n  margin: 0 0 18px;\n  padding: 0 14px;\n  border-radius: 14px;\n  border: 1px solid rgba(213, 167, 96, 0.22);\n  background: rgba(0, 0, 0, 0.28);\n  color: #d5a760;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.otc-desk-flow__search:focus-within {\n  border-color: rgba(213, 167, 96, 0.55);\n  box-shadow: 0 0 0 3px rgba(213, 167, 96, 0.12);\n}\n\n.otc-desk-flow__search input {\n  flex: 1;\n  min-width: 0;\n  border: 0;\n  background: transparent;\n  color: #f5f5f5;\n  font: inherit;\n  outline: none;\n}\n\n.otc-desk-flow__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(168px, 1fr));\n  gap: 14px;\n}\n\n.otc-desk-pair {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  min-height: 148px;\n  text-align: left;\n  padding: 18px 16px 16px;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background:\n    linear-gradient(160deg, rgba(36, 40, 50, 0.92), rgba(14, 16, 22, 0.95));\n  color: #f5f5f5;\n  cursor: pointer;\n  overflow: hidden;\n  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n}\n\n.otc-desk-pair__glow {\n  position: absolute;\n  top: 0;\n  left: 16px;\n  right: 16px;\n  height: 2px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, transparent, rgba(231, 201, 138, 0.75), transparent);\n  opacity: 0.55;\n  transition: opacity 0.2s ease;\n}\n\n.otc-desk-pair:hover,\n.otc-desk-pair:focus-visible {\n  outline: none;\n  border-color: rgba(213, 167, 96, 0.75);\n  background:\n    radial-gradient(ellipse 90% 70% at 50% 0%, rgba(213, 167, 96, 0.16), transparent 55%),\n    linear-gradient(160deg, rgba(42, 38, 30, 0.95), rgba(14, 16, 22, 0.98));\n  transform: translateY(-3px);\n  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(213, 167, 96, 0.12);\n}\n\n.otc-desk-pair:hover .otc-desk-pair__glow,\n.otc-desk-pair:focus-visible .otc-desk-pair__glow {\n  opacity: 1;\n}\n\n.otc-desk-pair__symbol {\n  font-size: 1.05rem;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n}\n\n.otc-desk-pair__price {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.otc-desk-pair__price span {\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.otc-desk-pair__price strong {\n  color: #e7c98a;\n  font-size: 1.05rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.otc-desk-pair__cta {\n  margin-top: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: #d5a760;\n  transition: gap 0.18s ease;\n}\n\n.otc-desk-pair:hover .otc-desk-pair__cta {\n  gap: 6px;\n}\n\n.otc-desk-flow__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 40px 16px;\n  color: #9ca3af;\n}\n\n.otc-desk-flow__pending {\n  margin-top: 20px;\n}\n\n.otc-quote-modal-wrap {\n  padding: 48px 16px 40px;\n  align-items: center;\n  justify-content: center;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n.otc-quote-modal {\n  width: min(540px, 100%);\n  max-height: min(calc(100vh - 96px), 820px);\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 18px 20px 28px;\n  border-radius: 22px;\n  margin: auto;\n  animation: otc-quote-pop 0.22s ease-out;\n  scrollbar-gutter: stable;\n}\n\n.otc-quote-modal--themed {\n  position: relative;\n  border: 1px solid rgba(213, 167, 96, 0.32);\n  background:\n    radial-gradient(ellipse 80% 50% at 80% -10%, rgba(231, 201, 138, 0.18), transparent 50%),\n    radial-gradient(ellipse 60% 40% at 0% 100%, rgba(213, 167, 96, 0.1), transparent 45%),\n    linear-gradient(180deg, rgba(30, 34, 42, 0.99), rgba(14, 16, 22, 0.99));\n  box-shadow:\n    0 28px 64px rgba(0, 0, 0, 0.55),\n    0 0 40px rgba(213, 167, 96, 0.06),\n    0 0 0 1px rgba(255, 255, 255, 0.04) inset;\n}\n\n.otc-quote-modal--themed::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 0 auto;\n  height: 2px;\n  background: linear-gradient(90deg, transparent 5%, rgba(231, 201, 138, 0.85), transparent 95%);\n  pointer-events: none;\n}\n\n.otc-quote-modal-wrap .otc-trade-overlay,\n.otc-quote-modal-wrap.otc-trade-overlay {\n  background: rgba(4, 6, 10, 0.78);\n  backdrop-filter: blur(10px);\n}\n\n.otc-quote-modal__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 32px;\n  margin: 0 0 8px;\n}\n\n.otc-quote-modal__top .otc-quote-back {\n  gap: 2px;\n  font-size: 0.9rem;\n}\n\n.otc-quote-modal__top .otc-trade-close {\n  position: static;\n  top: auto;\n  right: auto;\n  width: 34px;\n  height: 34px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.04);\n  color: #d5a760;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.otc-quote-modal__top .otc-trade-close:hover {\n  background: rgba(213, 167, 96, 0.12);\n  border-color: rgba(213, 167, 96, 0.45);\n}\n\n.otc-quote-modal__eyebrow {\n  margin: 0 0 4px;\n  font-size: 0.7rem;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #d5a760;\n}\n\n.otc-quote-modal .otc-card-title {\n  margin: 0 0 6px;\n  padding-right: 0;\n  font-size: 1.28rem;\n  line-height: 1.25;\n  font-weight: 800;\n  background: linear-gradient(120deg, #fff 30%, #e7c98a 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.otc-quote-modal__hint {\n  margin: 0 0 14px;\n  color: #9ca3af;\n  font-size: 0.84rem;\n  line-height: 1.4;\n}\n\n.otc-quote-modal .otc-flow-steps {\n  margin: 0 0 14px;\n  padding: 12px 8px 10px;\n}\n\n.otc-quote-modal .otc-flow-steps__track {\n  top: 26px;\n}\n\n.otc-quote-modal .otc-trade-kind-tabs {\n  display: inline-flex;\n  gap: 6px;\n  margin: 0 0 12px;\n  padding: 4px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(0, 0, 0, 0.28);\n}\n\n.otc-quote-modal .otc-trade-kind-tabs button {\n  border: 0;\n  border-radius: 999px;\n  padding: 0.45rem 1.05rem;\n}\n\n.otc-quote-modal .otc-trade-kind-tabs button.is-on {\n  box-shadow: 0 6px 14px rgba(213, 167, 96, 0.28);\n}\n\n.otc-quote-modal .otc-pair-search {\n  margin: 0 0 12px;\n}\n\n.otc-quote-modal .otc-pair-search .quote-input-card {\n  border-radius: 14px;\n  height: 46px;\n  border-color: rgba(213, 167, 96, 0.22);\n  background: rgba(0, 0, 0, 0.3);\n}\n\n.otc-quote-modal .otc-pair-search .quote-input-card:focus-within {\n  border-color: rgba(213, 167, 96, 0.55);\n  box-shadow: 0 0 0 3px rgba(213, 167, 96, 0.12);\n}\n\n.otc-quote-modal .otc-active-rail,\n.otc-quote-modal .otc-active-rail--quote {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 8px;\n  margin: 0 0 14px;\n  max-height: none;\n  overflow: visible;\n}\n\n.otc-quote-modal .otc-active-rail button {\n  padding: 11px 6px;\n  border-radius: 14px;\n  gap: 5px;\n  border-color: rgba(255, 255, 255, 0.1);\n  background: linear-gradient(180deg, rgba(36, 40, 50, 0.9), rgba(12, 14, 18, 0.95));\n  transition: border-color 0.18s ease, background 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.otc-quote-modal .otc-active-rail button:hover {\n  border-color: rgba(213, 167, 96, 0.5);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);\n}\n\n.otc-quote-modal .otc-active-rail button.is-on {\n  border-color: rgba(213, 167, 96, 0.9);\n  background: linear-gradient(180deg, rgba(231, 201, 138, 0.28), rgba(213, 167, 96, 0.12));\n  box-shadow: 0 0 0 1px rgba(213, 167, 96, 0.2), 0 8px 18px rgba(213, 167, 96, 0.15);\n}\n\n.otc-quote-modal .otc-active-rail button span:first-child {\n  font-size: 12px;\n}\n\n.otc-quote-modal .otc-active-rail button span:last-child {\n  font-size: 11px;\n  font-weight: 600;\n  opacity: 0.85;\n  font-variant-numeric: tabular-nums;\n}\n\n.otc-quote-modal .quote-field-group {\n  margin-bottom: 12px;\n}\n\n.otc-quote-modal .quote-field-header {\n  gap: 8px;\n  align-items: flex-start;\n}\n\n.otc-quote-modal .quote-avail-wrap {\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  max-width: 70%;\n}\n\n.otc-quote-modal .quote-amount-card {\n  border-radius: 14px;\n  height: 52px;\n  border-color: rgba(213, 167, 96, 0.2);\n  background: rgba(0, 0, 0, 0.32);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);\n}\n\n.otc-quote-modal .quote-amount-card:focus-within {\n  border-color: rgba(213, 167, 96, 0.55);\n  box-shadow: 0 0 0 3px rgba(213, 167, 96, 0.12);\n}\n\n.otc-quote-modal .otc-coin-label {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: rgba(213, 167, 96, 0.14);\n  border: 1px solid rgba(213, 167, 96, 0.28);\n  color: #e7c98a !important;\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.03em;\n}\n\n.otc-quote-modal .otc-trade-swap-wrap {\n  margin: 0 0 8px;\n}\n\n.otc-quote-modal .otc-trade-swap {\n  width: 40px;\n  height: 40px;\n  border-color: rgba(213, 167, 96, 0.4);\n  background: linear-gradient(180deg, rgba(40, 36, 28, 0.95), rgba(20, 18, 14, 0.98));\n  color: #e7c98a;\n  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.otc-quote-modal .otc-trade-swap:hover {\n  transform: rotate(180deg);\n  box-shadow: 0 0 0 3px rgba(213, 167, 96, 0.15);\n}\n\n.otc-quote-modal__actions {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 10px;\n  margin-top: 8px;\n  padding: 4px 0 12px;\n}\n\n.otc-quote-modal__actions .btn-request-quote {\n  margin-top: 0;\n  border: 0;\n  border-radius: 14px;\n  min-height: 50px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);\n  color: #1b1b1b;\n  box-shadow: 0 12px 26px rgba(213, 167, 96, 0.32);\n}\n\n.otc-quote-modal__actions .btn-request-quote:disabled {\n  opacity: 0.45;\n  box-shadow: none;\n}\n\n.otc-quote-modal__actions .btn-request-quote:not(:disabled):hover {\n  filter: brightness(1.06);\n  transform: translateY(-1px);\n}\n\n.otc-quote-modal__actions .otc-trades-link {\n  align-self: center;\n  color: #d5a760;\n  font-weight: 700;\n  padding-bottom: 4px;\n}\n\n@keyframes otc-quote-pop {\n  from { opacity: 0; transform: translateY(10px) scale(0.98); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.otc-quote-modal__pair {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 0 0 16px;\n  padding: 14px 16px;\n  border-radius: 16px;\n  border: 1px solid rgba(213, 167, 96, 0.42);\n  background:\n    radial-gradient(ellipse 80% 100% at 0% 50%, rgba(231, 201, 138, 0.18), transparent 55%),\n    linear-gradient(135deg, rgba(231, 201, 138, 0.14), rgba(213, 167, 96, 0.05));\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05), 0 8px 18px rgba(0, 0, 0, 0.18);\n}\n\n.otc-quote-modal__pair-main {\n  min-width: 0;\n}\n\n.otc-quote-modal__pair-label {\n  display: block;\n  margin-bottom: 2px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.otc-quote-modal__pair strong {\n  font-size: 1.05rem;\n  line-height: 1.2;\n}\n\n.otc-quote-modal__pair-price {\n  text-align: right;\n}\n\n.otc-quote-modal__pair-price span {\n  display: block;\n  margin-bottom: 2px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.otc-quote-modal__pair-price strong {\n  color: #e7c98a;\n  font-variant-numeric: tabular-nums;\n  font-size: 1.05rem;\n  line-height: 1.2;\n}\n\nbody.light_theme .otc-desk-flow__lead {\n  color: #64748b;\n}\n\nbody.light_theme .otc-desk-flow .so-page__title {\n  background: none;\n  -webkit-background-clip: unset;\n  background-clip: unset;\n  color: #0f172a;\n}\n\nbody.light_theme .otc-flow-steps,\nbody.light_theme .otc-desk-flow__panel {\n  background: #fff;\n  border-color: #e8d7b4;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);\n}\n\nbody.light_theme .otc-flow-steps__track {\n  background: #e2e8f0;\n}\n\nbody.light_theme .otc-flow-steps__num {\n  background: #fff;\n}\n\nbody.light_theme .otc-desk-flow__panel-title,\nbody.light_theme .otc-desk-pair {\n  color: #0f172a;\n}\n\nbody.light_theme .otc-desk-pair {\n  background: linear-gradient(160deg, #fff, #f8fafc);\n  border-color: #e2e8f0;\n}\n\nbody.light_theme .otc-desk-pair:hover,\nbody.light_theme .otc-desk-pair:focus-visible {\n  background: linear-gradient(160deg, #fffaf0, #fff);\n  border-color: #d5a760;\n}\n\nbody.light_theme .otc-desk-flow .otc-trade-kind-tabs {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n}\n\nbody.light_theme .otc-desk-flow .otc-trade-kind-tabs button {\n  color: #475569;\n}\n\nbody.light_theme .otc-desk-flow__search {\n  background: #fff;\n  border-color: #e8d7b4;\n}\n\nbody.light_theme .otc-desk-flow__search input {\n  color: #0f172a;\n}\n\nbody.light_theme .otc-quote-modal--themed {\n  background: linear-gradient(180deg, #fff, #fbf7ef);\n  border-color: #e8d7b4;\n  box-shadow: 0 24px 56px rgba(15, 23, 42, 0.14);\n}\n\nbody.light_theme .otc-quote-modal .otc-card-title {\n  background: none;\n  -webkit-background-clip: unset;\n  background-clip: unset;\n  color: #0f172a;\n}\n\nbody.light_theme .otc-quote-modal__hint {\n  color: #64748b;\n}\n\nbody.light_theme .otc-quote-modal .otc-coin-label {\n  background: #fff8ee;\n  border-color: #e8d7b4;\n  color: #8a6a2f !important;\n}\n\nbody.light_theme .otc-quote-modal .quote-amount-card {\n  background: #f8fafc;\n  border-color: #e8d7b4;\n}\n\n@media (max-width: 720px) {\n  .otc-flow-steps__list {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .otc-flow-steps__copy em {\n    display: none;\n  }\n\n  .otc-flow-steps__track {\n    top: 28px;\n    left: 10%;\n    right: 10%;\n  }\n\n  .otc-desk-flow__grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .otc-desk-flow__panel-head {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .otc-quote-modal-wrap {\n    align-items: flex-end;\n    padding: 12px 8px calc(12px + env(safe-area-inset-bottom, 0px));\n  }\n\n  .otc-quote-modal {\n    width: 100%;\n    max-height: calc(100vh - 48px - env(safe-area-inset-bottom, 0px));\n    border-radius: 16px 16px 12px 12px;\n    padding-bottom: 24px;\n  }\n}\n\n.otc-trade-shell__top {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 20px;\n  margin: 0 0 22px;\n}\n\n.otc-trade-shell__title {\n  margin: 6px 0 4px;\n  font-size: clamp(1.5rem, 2.4vw, 2rem);\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  color: #f5f5f5;\n}\n\n.otc-trade-shell__sub {\n  margin: 0;\n  max-width: 42ch;\n  color: #9ca3af;\n  font-size: 0.92rem;\n  line-height: 1.45;\n}\n\n.otc-trade-steps {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.otc-trade-steps li {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(28, 33, 40, 0.9);\n  color: #9ca3af;\n  font-size: 0.82rem;\n  font-weight: 700;\n}\n\n.otc-trade-steps li span {\n  display: inline-grid;\n  place-items: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.08);\n  color: #d5a760;\n  font-size: 0.75rem;\n}\n\n.otc-trade-steps li.is-on {\n  border-color: rgba(213, 167, 96, 0.55);\n  background: linear-gradient(180deg, rgba(231, 201, 138, 0.18), rgba(213, 167, 96, 0.1));\n  color: #f5f5f5;\n  box-shadow: 0 0 0 1px rgba(213, 167, 96, 0.2);\n}\n\n.otc-trade-steps li.is-done {\n  border-color: rgba(213, 167, 96, 0.35);\n  color: #e7c98a;\n}\n\n.otc-trade-steps li.is-done span,\n.otc-trade-steps li.is-on span {\n  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);\n  color: #1b1b1b;\n}\n\n.otc-trade-shell__grid {\n  display: grid;\n  grid-template-columns: minmax(280px, 360px) minmax(0, 1fr);\n  gap: 18px;\n  align-items: start;\n}\n\n.otc-trade-rail {\n  background: #1c2128;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 18px;\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.28);\n  overflow: hidden;\n  min-height: 560px;\n  display: flex;\n  flex-direction: column;\n}\n\n.otc-trade-rail__tabs {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  background: #171b20;\n}\n\n.otc-trade-rail__tabs button {\n  border: 0;\n  background: transparent;\n  color: #9ca3af;\n  font-weight: 700;\n  font-size: 0.82rem;\n  padding: 14px 8px;\n  cursor: pointer;\n}\n\n.otc-trade-rail__tabs button.is-on {\n  color: #1b1b1b;\n  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);\n}\n\n.otc-trade-rail__body {\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n}\n\n.otc-trade-rail__list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.otc-trade-rail__pair {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  width: 100%;\n  text-align: left;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.03);\n  color: #f5f5f5;\n  border-radius: 12px;\n  padding: 12px 14px;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, transform 0.15s ease;\n}\n\n.otc-trade-rail__pair:hover {\n  border-color: rgba(213, 167, 96, 0.45);\n  background: rgba(213, 167, 96, 0.08);\n}\n\n.otc-trade-rail__pair.is-on {\n  border-color: rgba(213, 167, 96, 0.7);\n  background: linear-gradient(135deg, rgba(231, 201, 138, 0.16), rgba(213, 167, 96, 0.08));\n  box-shadow: inset 0 0 0 1px rgba(213, 167, 96, 0.25);\n}\n\n.otc-trade-rail__pair strong {\n  font-size: 0.95rem;\n}\n\n.otc-trade-rail__pair span {\n  color: #d5a760;\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n  font-size: 0.85rem;\n}\n\n.otc-trade-rail__filters {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.otc-trade-rail__filters select,\n.otc-trade-rail__filters input[type=\"date\"] {\n  height: 38px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(255, 255, 255, 0.04);\n  color: #f5f5f5;\n  padding: 0 10px;\n  font: inherit;\n  font-size: 0.8rem;\n}\n\n.otc-trade-main {\n  min-width: 0;\n}\n\n.otc-trade-home-card.otc-trade-main-card {\n  width: 100%;\n  max-width: none;\n  max-height: none;\n  margin: 0;\n  padding: 22px 24px 28px;\n  border-radius: 18px;\n  box-sizing: border-box;\n}\n\n.otc-trade-main__pair {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 0 0 14px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  background: rgba(213, 167, 96, 0.08);\n  border: 1px solid rgba(213, 167, 96, 0.28);\n}\n\n.otc-trade-main__pair span {\n  font-weight: 800;\n  letter-spacing: 0.02em;\n}\n\n.otc-trade-main__pair strong {\n  color: #e7c98a;\n  font-variant-numeric: tabular-nums;\n}\n\nbody.light_theme .otc-trade-shell {\n  background:\n    radial-gradient(ellipse 80% 50% at 10% -10%, rgba(213, 167, 96, 0.18), transparent 55%),\n    #f4f6f8;\n  color: #0f172a;\n}\n\nbody.light_theme .otc-trade-shell__title {\n  color: #0f172a;\n}\n\nbody.light_theme .otc-trade-shell__sub {\n  color: #64748b;\n}\n\nbody.light_theme .otc-trade-steps li {\n  background: #fff;\n  border-color: #e2e8f0;\n  color: #64748b;\n}\n\nbody.light_theme .otc-trade-rail {\n  background: #fff;\n  border-color: #e2e8f0;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);\n}\n\nbody.light_theme .otc-trade-rail__tabs {\n  background: #f8fafc;\n  border-bottom-color: #e2e8f0;\n}\n\nbody.light_theme .otc-trade-rail__pair {\n  background: #f8fafc;\n  border-color: #e2e8f0;\n  color: #0f172a;\n}\n\nbody.light_theme .otc-trade-rail__pair.is-on {\n  background: #fff8eb;\n  border-color: #d5a760;\n}\n\nbody.light_theme .otc-trade-rail__filters select,\nbody.light_theme .otc-trade-rail__filters input[type=\"date\"] {\n  background: #fff;\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n@media (max-width: 960px) {\n  .otc-trade-shell__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .otc-trade-rail {\n    min-height: 0;\n    max-height: 420px;\n  }\n}\n\n.otc-trade-home-card {\n  position: relative;\n  width: min(520px, 100%);\n  max-height: 92vh;\n  overflow: auto;\n  background: #1c2128;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);\n  color: #f5f5f5;\n}\n\n.otc-quote-back {\n  display: inline-flex;\n  align-items: center;\n  margin: 0;\n  padding: 4px 0;\n  border: 0;\n  background: transparent;\n  color: #d5a760;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.otc-trade-home-card .otc-card-title {\n  padding-right: 42px;\n}\n\nbody.light_theme .otc-quote-back {\n  color: #8a6a2f;\n}\n\n.otc-trade-desk .otc-trade-home-card .otc-card-title,\n.otc-trade-desk .otc-trade-home-card .quote-live-last,\n.otc-trade-desk .otc-trade-home-card .quote-field-input,\n.otc-trade-desk .otc-trade-home-card .otc-coin-label {\n  color: #f5f5f5;\n}\n\n.otc-trade-desk .otc-trade-home-card .quote-field-label,\n.otc-trade-desk .otc-trade-home-card .quote-avail-text {\n  color: #9ca3af;\n}\n\n.otc-trade-desk .otc-trade-home-card .quote-input-card {\n  width: 100%;\n  box-sizing: border-box;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  box-shadow: none;\n}\n\n.otc-trade-desk .otc-trade-home-card .quote-field-input::placeholder {\n  color: #8b93a1;\n}\n\n.otc-trade-desk .otc-trade-home-card .otc-trade-kind-tabs button {\n  background: transparent;\n  color: #f5f5f5;\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.otc-trade-desk .otc-trade-home-card .otc-trade-kind-tabs button.is-on {\n  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);\n  color: #1b1b1b;\n  border-color: transparent;\n}\n\nbody.light_theme .otc-trade-desk .otc-trade-home.otc-trade-overlay {\n  background: rgb(255 255 255 / 46%);\n}\n\nbody.light_theme .otc-trade-home-card {\n  background: rgba(255, 255, 255, 0.50);\n  border: 1px solid rgba(255, 255, 255, 0.65);\n  box-shadow: 0 10px 30px rgb(0 0 0 / 30%);\n  color: #0f172a;\n}\n\nbody.light_theme .otc-trade-desk .otc-trade-home-card .otc-card-title,\nbody.light_theme .otc-trade-desk .otc-trade-home-card .quote-live-last,\nbody.light_theme .otc-trade-desk .otc-trade-home-card .quote-field-input,\nbody.light_theme .otc-trade-desk .otc-trade-home-card .otc-coin-label {\n  color: #0f172a;\n}\n\nbody.light_theme .otc-trade-desk .otc-trade-home-card .quote-field-label,\nbody.light_theme .otc-trade-desk .otc-trade-home-card .quote-avail-text {\n  color: #64748b;\n}\n\nbody.light_theme .otc-trade-desk .otc-trade-home-card .quote-input-card {\n  background: #f4f6f8;\n  border-color: #e5e7eb;\n  box-shadow: none;\n}\n\nbody.light_theme .otc-trade-desk .otc-trade-home-card .quote-field-input::placeholder {\n  color: #94a3b8;\n}\n\nbody.light_theme .otc-trade-desk .otc-trade-home-card .otc-trade-kind-tabs button {\n  background: #ffffff;\n  color: #334155;\n  border-color: #d7deea;\n}\n\nbody.light_theme .otc-trade-desk .otc-trade-home-card .otc-trade-kind-tabs button.is-on {\n  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);\n  color: #1b1b1b;\n  border-color: transparent;\n}\n\nbody.light_theme .otc-trade-desk .otc-trade-swap {\n  background: #ffffff;\n  border-color: #e5e7eb;\n}\n\nbody.light_theme .otc-pair-search-list {\n  background: #ffffff;\n  border-color: #e5e7eb;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);\n}\n\nbody.light_theme .otc-pair-search-list button {\n  color: #0f172a;\n}\n\nbody.light_theme .otc-pair-search-empty {\n  color: #64748b;\n}\n\n.otc-trade-desk .otc-suite-header {\n  margin-bottom: 16px;\n}\n\n.otc-exchange-tabs {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  margin: 0 0 28px;\n}\n\n.otc-exchange-tabs button {\n  border: 1px solid rgba(213, 167, 96, 0.45);\n  background: transparent;\n  color: #f5f5f5;\n  border-radius: 999px;\n  padding: 10px 22px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.otc-exchange-tabs button.is-on {\n  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);\n  color: #1b1b1b;\n  border-color: transparent;\n}\n\nbody.light_theme .otc-exchange-tabs button {\n  color: #1b1b1b;\n}\n\n.otc-trade-desk .otc-rfq-card .quote-field-input {\n  width: auto;\n  height: auto;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  padding: 0;\n  box-shadow: none;\n}\n\n.otc-trade-desk .otc-trade-kind-tabs {\n  justify-content: flex-start;\n  margin: 0 0 24px;\n}\n\n.otc-trade-desk .otc-pair-search {\n  position: relative;\n  width: 100%;\n  height: auto;\n  margin: 0 0 14px;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none;\n  z-index: 4;\n}\n\n.otc-trade-desk .otc-pair-search .quote-input-card {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  height: 48px;\n  margin: 0;\n  padding: 0 16px;\n  border-radius: 50px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  box-shadow: none;\n  box-sizing: border-box;\n}\n\n.otc-trade-desk .otc-pair-search .quote-input-card:focus-within {\n  border-color: #d5a760;\n}\n\nbody.light_theme .otc-trade-desk .otc-pair-search {\n  width: 100%;\n  height: auto;\n  background: transparent;\n  border: 0;\n}\n\nbody.light_theme .otc-trade-desk .otc-pair-search .quote-input-card {\n  background: #f4f6f8;\n  border-color: #d7deea;\n}\n\n.otc-trade-desk .otc-rfq-card .otc-pair-search .quote-field-input {\n  flex: 1;\n  width: 100%;\n  min-width: 0;\n}\n\n.otc-trade-desk .otc-pair-search .ri-search-line {\n  color: #9ca3af;\n  font-size: 18px;\n}\n\n.otc-pair-search-list {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(100% + 6px);\n  z-index: 6;\n  margin: 0;\n  padding: 6px;\n  list-style: none;\n  background: #171b20;\n  border: 1px solid #686868;\n  border-radius: 16px;\n  max-height: 240px;\n  overflow: auto;\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.35);\n}\n\n.otc-pair-search-list button {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  border: 0;\n  background: transparent;\n  color: #fff;\n  border-radius: 10px;\n  padding: 10px 12px;\n  cursor: pointer;\n  font-weight: 700;\n}\n\n.otc-pair-search-list button.is-on,\n.otc-pair-search-list button:hover {\n  background: rgba(213, 167, 96, 0.16);\n}\n\n.otc-pair-search-empty {\n  padding: 10px 12px;\n  color: #9ca3af;\n}\n\n.otc-trade-desk .otc-active-rail {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 6px;\n  margin: 0 0 14px;\n}\n\n.otc-trade-desk .otc-active-rail button {\n  min-width: 0;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background: rgba(255, 255, 255, 0.06);\n  color: #f5f5f5;\n  border-radius: 12px;\n  padding: 8px 4px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n}\n\n.otc-trade-desk .otc-active-rail button span {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.otc-trade-desk .otc-active-rail button.is-on {\n  border-color: #d5a760;\n  background: rgba(213, 167, 96, 0.2);\n}\n\nbody.light_theme .otc-trade-desk .otc-active-rail button {\n  background: #f4f6f8;\n  border-color: #d7deea;\n  color: #0f172a;\n}\n\nbody.light_theme .otc-trade-desk .otc-active-rail button.is-on {\n  border-color: #d5a760;\n  background: #fff8ee;\n}\n\n.otc-trade-desk .otc-rfq-card .quote-pair-price-row.quote-input-card {\n  padding-right: 16px;\n}\n\n.otc-trade-desk .otc-rfq-card .otc-coin-label {\n  color: #fff;\n  font-weight: 700;\n}\n\n.otc-trades-link {\n  display: block;\n  width: 100%;\n  margin-top: 12px;\n  border: 0;\n  background: transparent;\n  color: #d5a760;\n  font-weight: 500;\n  cursor: pointer;\n  text-align: center;\n}\n\n.otc-trades-screen {\n  width: min(640px, 100%);\n}\n\n.otc-trades-screen .otc-trade-kind-tabs {\n  margin-top: 14px;\n}\n\n.otc-my-trades {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.otc-my-trade {\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 14px;\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.otc-my-trade strong {\n  display: block;\n  font-size: 14px;\n}\n\n.otc-my-trade span {\n  color: #9ca3af;\n  font-size: 12px;\n}\n\n.otc-my-trade p {\n  margin: 8px 0;\n}\n\n.otc-my-trade-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 18px;\n}\n\n.otc-my-trade-actions button {\n  border: 1px solid rgba(213, 167, 96, 0.5);\n  background: transparent;\n  color: #e7c98a;\n  border-radius: 999px;\n  padding: 4px 20px;\n  font-weight: 500;\n  cursor: pointer;\n  font-size: 13px;\n}\n\nbody.light_theme .otc-my-trade {\n  background: #f8fafc;\n  border-color: #e5e7eb;\n  color: #0f172a;\n}\n\nbody.light_theme .otc-my-trade span {\n  color: #64748b;\n}\n\nbody.light_theme .otc-my-trade-actions button {\n  color: #8a6a2f;\n  background: #fff;\n}\n\nbody.light_theme .otc-status-chip {\n  color: #8a6a2f;\n}\n\nbody.light_theme .otc-status-chip.is-done {\n  color: #0f7a4a;\n}\n\nbody.light_theme .otc-status-chip.is-bad {\n  color: #b42318;\n}\n\n.otc-open-requests {\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n  margin-top: 12px;\n}\n\nbody.light_theme .otc-trade-overlay {\n  background-color: rgb(255 255 255 / 60%);\n}\n\n.otc-open-requests button {\n  flex: 0 0 auto;\n  border: 0;\n  background: transparent;\n  color: #d5a760;\n  cursor: pointer;\n  font-weight: 700;\n}\n\n.otc-trade-swap-wrap {\n  display: flex;\n  justify-content: center;\n  padding-top: 4px;\n  margin: 0px 0 8px;\n  position: relative;\n  z-index: 2;\n}\n\n.otc-trade-swap {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid #686868;\n  background: #1c2128;\n  color: #d5a760;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n}\n\n.otc-trade-desk .btn-request-quote,\n.otc-trade-form-popup .btn-request-quote {\n  width: 100%;\n  margin-top: 8px;\n  position: relative;\n  z-index: 2;\n}\n\n.otc-trade-desk .otc-trade-list {\n  margin-top: 0;\n}\n\n.otc-trade-panel {\n  max-width: 760px;\n  margin: 32px auto;\n  padding: 24px;\n  border: 1px solid rgba(213, 167, 96, 0.35);\n  border-radius: 16px;\n  background: #12151b;\n  color: #f5f5f5;\n}\n\nbody.light_theme .otc-trade-panel {\n  background: #fff;\n  color: #1b1b1b;\n}\n\n.otc-trade-row {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 14px;\n}\n\n.otc-trade-row label,\n.otc-trade-field span {\n  display: block;\n  font-size: 12px;\n  opacity: 0.75;\n  margin-bottom: 6px;\n}\n\n.otc-trade-field {\n  flex: 1;\n  min-width: 180px;\n}\n\n.otc-trade-panel input,\n.otc-trade-panel select {\n  width: 100%;\n  border-radius: 10px;\n  border: 1px solid rgba(213, 167, 96, 0.4);\n  background: transparent;\n  color: inherit;\n  padding: 10px 12px;\n}\n\n.otc-trade-actions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.otc-trade-swap {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  border: 1px solid #d5a760;\n  background: transparent;\n  color: #d5a760;\n  cursor: pointer;\n}\n\n.otc-trade-note {\n  font-size: 13px;\n  margin: 8px 0;\n}\n\n.otc-trade-error {\n  color: #ff8d8d;\n}\n\n.otc-trade-overlay {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 99999999999;\n  background-color: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n/* Keep orders sidebar visible and clickable while OTC popups are open */\n@media (min-width: 992px) {\n  .otc-trade-overlay.otc-trade-overlay--aside-safe {\n    left: 324px;\n    z-index: 90;\n  }\n\n  body:has(.dashboard--sidebar-collapsed) .otc-trade-overlay.otc-trade-overlay--aside-safe {\n    left: 76px;\n  }\n\n  body:has(.otc-trade-overlay--aside-safe) .profile-sidebar-shell.leftside_menu {\n    position: relative;\n    z-index: 120;\n  }\n}\n\n.otc-trade-overlay .otc-card-title {\n  font-size: 22px;\n}\n\n.otc-trade-overlay .otc-exchange-tabs button {\n  padding: 6px 22px;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.otc-trade-overlay .otc-quote-back {\n  font-weight: 400;\n  font-size: 13px;\n}\n\n.otc-trade-overlay .otc-trade-home-card {\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  background: rgb(26 26 26 / 20%);\n  border-radius: 22px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  box-shadow: inset 0 1px 0 rgb(0 0 0 / 50%), 0 28px 64px rgba(0, 0, 0, 0.48);\n}\n\n.otc-trade-popup {\n  position: relative;\n  width: min(520px, 100%);\n  min-height: 300px;\n  max-height: 90vh;\n  overflow: auto;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  color: #fff;\n  padding: 24px;\n  background: rgb(26 26 26 / 20%);\n  border-radius: 22px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  box-shadow: inset 0 1px 0 rgb(0 0 0 / 50%), 0 28px 64px rgba(0, 0, 0, 0.48);\n\n}\n\n.otc-trade-popup .otc-exchange-tabs.otc-trade-kind-tabs {\n  justify-content: start;\n}\n\n.otc-trade-popup.otc-trade-home-card {\n  /* border-radius: 20px;\n  padding: 24px;\n  background: #1c2128;\n  border: 1px solid rgba(255, 255, 255, 0.12); */\n  color: #f5f5f5;\n}\n\nbody.light_theme .otc-trade-popup.otc-trade-home-card {\n  /* background: #ffffff;\n  border-color: #e6e8ee; */\n  color: #0f172a;\n}\n\n.otc-trade-popup.otc-trade-home-card .otc-card-title {\n  margin-bottom: 8px;\n}\n\n.otc-trade-popup.otc-trade-home-card .otc-trade-lead {\n  margin-bottom: 16px;\n}\n\n.otc-trade-popup h2 {\n  margin: 0 0 6px;\n  font-size: 22px;\n  line-height: 1.25;\n  padding-right: 40px;\n}\n\n.otc-trade-lead {\n  margin: 0;\n  color: #9ca3af;\n  font-size: 14px;\n}\n\n.otc-trade-amounts {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin: 16px 0 4px;\n}\n\n.otc-trade-amounts div {\n  border: 1px solid rgba(213, 167, 96, 0.35);\n  border-radius: 12px;\n  padding: 12px 14px;\n  background: rgba(213, 167, 96, 0.08);\n}\n\n.otc-trade-amounts span {\n  display: block;\n  font-size: 12px;\n  color: #9ca3af;\n  margin-bottom: 4px;\n}\n\n.otc-trade-amounts strong {\n  display: block;\n  font-size: 16px;\n  line-height: 1.3;\n  word-break: break-word;\n}\n\n.otc-trade-footer-one {\n  grid-template-columns: 1fr;\n}\n\n.otc-trade-footer {\n  display: grid;\n  grid-template-columns: 1fr 1.35fr;\n  gap: 12px;\n  margin-top: 18px;\n  padding-top: 16px;\n  border-top: 1px solid rgba(213, 167, 96, 0.28);\n}\n\n.otc-trade-footer button {\n  height: 44px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.otc-trade-back {\n  background: transparent;\n  color: #f5f5f5;\n  border: 1px solid rgba(255, 255, 255, 0.22);\n}\n\n.otc-trade-back:hover:not(:disabled) {\n  border-color: #d5a760;\n  color: #e7c98a;\n}\n\n.otc-trade-confirm {\n  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);\n  color: #1b1b1b;\n  border: none;\n}\n\n.otc-trade-confirm:hover:not(:disabled) {\n  filter: brightness(1.05);\n}\n\n.otc-trade-footer button:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.otc-trade-close {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  border-radius: 50%;\n  border: none;\n  background: transparent;\n  color: inherit;\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n}\n\nbody.light_theme .otc-trade-popup {\n  background: rgba(255, 255, 255, 0.20);\n  border: 1px solid rgba(255, 255, 255, 0.65);\n  box-shadow: 0 10px 30px rgb(0 0 0 / 15%);\n  color: #1b1b1b;\n}\n\nbody.light_theme .otc-trade-lead,\nbody.light_theme .otc-trade-amounts span {\n  color: #64748b;\n}\n\nbody.light_theme .otc-trade-amounts div {\n  background: #fbf7ef;\n}\n\nbody.light_theme .otc-trade-back {\n  color: #1b1b1b;\n  border-color: #d7deea;\n  background: #fff;\n}\n\n.otc-trade-popup dl {\n  display: grid;\n  grid-template-columns: 140px 1fr;\n  gap: 10px 16px;\n  margin: 16px 0;\n}\n\n.otc-trade-popup dt,\n.otc-trade-popup dd {\n  margin: 0;\n}\n\n.otc-trade-popup dt {\n  opacity: 0.7;\n}\n\n.otc-trade-popup dd {\n  font-weight: 600;\n  word-break: break-word;\n}\n\n.otc-trade-detail {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 12px;\n  font-size: 13px;\n}\n\n.otc-trade-detail span {\n  opacity: 0.75;\n}\n\n.otc-trade-detail input,\n.otc-trade-detail select {\n  width: 100%;\n  height: 42px;\n  border-radius: 10px;\n  border: 1px solid rgba(213, 167, 96, 0.55);\n  background: transparent;\n  color: inherit;\n  padding: 0 12px;\n}\n\n.otc-trade-detail input::placeholder {\n  color: #9ca3af;\n  opacity: 1;\n}\n\n.otc-trade-detail input[readonly] {\n  cursor: default;\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.otc-receive-choice {\n  border: 1px solid rgba(213, 167, 96, 0.35);\n  border-radius: 10px;\n  padding: 12px;\n  margin: 0;\n}\n\n.otc-receive-choice legend {\n  padding: 0 4px;\n  opacity: 0.75;\n  font-size: 13px;\n}\n\n.otc-receive-choice__option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 8px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.otc-receive-choice__option input {\n  width: auto;\n  height: auto;\n  margin: 0;\n}\n\n.otc-request-head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.otc-request-head .otc-card-title {\n  margin-bottom: 4px;\n}\n\n.otc-history-btn,\n.otc-request-action {\n  height: 34px;\n  padding: 0 14px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.otc-history-btn {\n  border: 1px solid rgba(213, 167, 96, 0.7);\n  background: transparent;\n  color: #e7c98a;\n}\n\n.otc-request-action {\n  border: none;\n  background: #d1aa67;\n  color: #1b1b1b;\n}\n\n.otc-request-list {\n  margin-top: 8px;\n}\n\n.otc-request-row {\n  display: grid;\n  grid-template-columns: minmax(140px, 1.2fr) minmax(90px, 0.8fr) minmax(120px, 1fr) minmax(130px, 1.1fr) minmax(140px, 1.1fr) 200px;\n  min-width: 900px;\n  align-items: center;\n  gap: 10px;\n  min-height: 52px;\n  padding: 8px 4px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  font-size: 13px;\n}\n\n.otc-request-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.otc-history-row {\n  grid-template-columns: minmax(140px, 1.15fr) minmax(90px, 0.7fr) minmax(90px, 0.7fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(110px, 0.9fr) 72px;\n  min-width: 900px;\n}\n\n.otc-history-back {\n  margin: 0 0 10px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #e7c98a;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.otc-history-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 12px;\n  margin: 8px 0 14px;\n}\n\n.otc-history-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  color: #9ca3af;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.otc-history-date {\n  height: 42px;\n  min-width: 150px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background: rgba(0, 0, 0, 0.25);\n  color: #fff;\n  color-scheme: dark;\n  padding: 0 12px;\n  font-size: 14px;\n}\n\nbody.light_theme .otc-history-date {\n  background: #fff;\n  color: #0f172a;\n  border-color: #e2e8f0;\n  color-scheme: light;\n}\n\nbody.light_theme .otc-history-back,\nbody.light_theme .otc-history-field {\n  color: #8a6a2f;\n}\n\nbody.light_theme .otc-history-field {\n  color: #64748b;\n}\n\n.otc-history-page .otc-request-list {\n  flex: 1;\n  max-height: none;\n}\n\n.otc-trade-desk.is-history {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.otc-trade-desk.is-history .otc-trading-suite-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 16px;\n}\n\n.otc-trade-desk.is-history .otc-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.otc-trade-desk.is-history .otc-history-page {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 0;\n}\n\n.otc-request-head-row {\n  min-height: 36px;\n  color: #9ca3af;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.otc-request-head-row>span:last-child {\n  text-align: right;\n}\n\n.otc-status-chip {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 999px;\n  padding: 4px 10px;\n  background: rgb(209 170 103 / 16%);\n  color: #e7c98a;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.otc-status-chip.is-live {\n  background: rgb(209 170 103 / 24%);\n  color: #f3d7a1;\n}\n\n.otc-status-chip.is-done {\n  background: rgba(43, 194, 135, 0.16);\n  color: #7dcea0;\n}\n\n.otc-status-chip.is-bad {\n  background: rgba(255, 107, 107, 0.14);\n  color: #ff9b9b;\n}\n\n.otc-history-status {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.otc-history-reason {\n  color: #9ca3af;\n  font-size: 12px;\n  line-height: 1.35;\n}\n\n.otc-trade-history-popup {\n  width: min(920px, 100%);\n}\n\n.otc-trade-list {\n  margin-top: 18px;\n}\n\n.otc-trade-list table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.otc-trade-list th,\n.otc-trade-list td {\n  text-align: left;\n  padding: 8px 6px;\n  border-bottom: 1px solid rgba(213, 167, 96, 0.25);\n}\n\n.otc-trade-form-popup {\n  width: min(640px, 100%);\n}\n\n.otc-trade-form-popup .otc-exchange-tabs {\n  justify-content: flex-start;\n  margin: 14px 0 16px;\n}\n\n.otc-trade-form-popup .quote-pair-price-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 16px;\n}\n\n.otc-trade-form-popup .otc-trade-field {\n  flex: 1;\n}\n\n.otc-trade-desk .otc-container {\n  width: 100%;\n  max-width: none;\n  padding: 0 28px;\n  box-sizing: border-box;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.otc-desk-layout {\n  display: grid;\n  grid-template-columns: 220px minmax(0, 1fr);\n  gap: 18px;\n  align-items: stretch;\n  flex: 1;\n}\n\n.otc-desk-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  background: rgb(255 255 255 / 10%);\n  box-shadow: inset 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n.otc-desk-nav button {\n  height: 44px;\n  border-radius: 999px;\n  border: 1px solid rgba(213, 167, 96, 0.45);\n  background: transparent;\n  color: #f5f5f5;\n  font: inherit;\n  font-weight: 700;\n  cursor: pointer;\n  text-align: left;\n  padding: 0 16px;\n}\n\n.otc-desk-nav button.is-on {\n  background: linear-gradient(180deg, #e7c98a 0%, #d5a760 100%);\n  color: #1b1b1b;\n  border-color: transparent;\n}\n\n.otc-desk-main {\n  min-width: 0;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.otc-desk-main>.otc-pair-board,\n.otc-desk-main>.otc-trade-list {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.otc-desk-main>.otc-pair-works {\n  flex: 0 0 auto;\n}\n\nbody.light_theme .otc-desk-nav {\n  background: rgb(0 0 0 / 5%);\n  border-color: #eff4fb;\n  box-shadow: inset 0 10px 30px rgba(0, 0, 0, 0.07);\n}\n\nbody.light_theme .otc-desk-nav button {\n  color: #1b1b1b;\n}\n\n.otc-pair-intro {\n  margin: 10px auto 0;\n  max-width: 640px;\n  color: #9ca3af;\n  font-size: 16px;\n}\n\n.otc-pair-filters {\n  justify-content: flex-end;\n  margin: 0;\n  flex-wrap: wrap;\n}\n\n.otc-pair-filters button {\n  padding: 8px 16px;\n}\n\n.otc-trade-notice {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  max-width: min(520px, calc(100vw - 32px));\n  padding: 12px 12px 12px 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(213, 167, 96, 0.45);\n  background: #1c2128;\n  color: #f5f5f5;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.otc-trade-notice button {\n  width: 28px;\n  height: 28px;\n  flex: 0 0 28px;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: #e7c98a;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.otc-pair-board {\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 20px;\n  background: rgb(255 255 255 / 10%);\n  box-shadow: inset 0 4px 20px rgba(0, 0, 0, 0.3);\n  padding: 22px 22px 8px;\n}\n\n.otc-pair-toolbar {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 8px;\n}\n\n.otc-pair-toolbar .otc-card-title {\n  margin-bottom: 4px;\n}\n\n.otc-pair-count {\n  margin: 0;\n  color: #9ca3af;\n  font-size: 13px;\n}\n\n.otc-pair-toolbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.otc-pair-search {\n  width: 220px;\n  height: 42px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background: rgba(0, 0, 0, 0.25);\n  color: #fff;\n  padding: 0 16px;\n  font-size: 14px;\n}\n\n.otc-pair-search:focus {\n  outline: none;\n  border-color: #d5a760;\n}\n\n.otc-pair-list,\n.otc-trade-desk .otc-request-list {\n  flex: 1 1 auto;\n  min-height: 0;\n  max-height: none;\n  overflow: auto;\n  margin: 0 -6px;\n}\n\n.otc-pair-row {\n  display: grid;\n  grid-template-columns: minmax(120px, 1.1fr) minmax(160px, 1.5fr) minmax(110px, 0.8fr) minmax(140px, 1fr) 92px;\n  min-width: 720px;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  min-height: 64px;\n  padding: 10px 12px;\n  border: 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: transparent;\n  color: #fff;\n  text-align: left;\n  font: inherit;\n  cursor: pointer;\n}\n\n.otc-pair-row-head {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  min-height: 40px;\n  cursor: default;\n  color: #9ca3af;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  background: #1a1e24;\n}\n\n.otc-pair-row:not(.otc-pair-row-head):hover {\n  background: rgba(209, 170, 103, 0.1);\n}\n\n.otc-pair-symbol {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.otc-pair-badge {\n  display: inline-flex;\n  border-radius: 999px;\n  padding: 4px 10px;\n  background: rgb(209 170 103 / 20%);\n  color: #d1aa67;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.otc-pair-price {\n  display: flex;\n  flex-direction: column;\n  font-size: 16px;\n  font-weight: 700;\n  color: #e7c98a;\n  line-height: 1.2;\n}\n\n.otc-pair-unit,\n.otc-pair-path {\n  color: #9ca3af;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.otc-pair-cta {\n  justify-self: end;\n  min-width: 78px;\n  height: 34px;\n  padding: 0 14px;\n  border-radius: 999px;\n  background: #d1aa67;\n  color: #1b1b1b;\n  font-size: 13px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.otc-pair-works {\n  margin-top: 16px;\n}\n\n.otc-pair-steps {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 18px;\n}\n\n.otc-pair-popup-price {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  margin: 14px 0 8px;\n}\n\n.otc-pair-popup-price .quote-live-last {\n  font-size: 28px;\n  color: #e7c98a;\n}\n\nbody.light_theme .otc-pair-intro,\nbody.light_theme .otc-pair-unit,\nbody.light_theme .otc-pair-path,\nbody.light_theme .otc-pair-count {\n  color: #64748b;\n}\n\nbody.light_theme .otc-pair-board {\n  background: rgb(0 0 0 / 5%);\n  border-color: #eff4fb;\n  box-shadow: inset 0 10px 30px rgba(0, 0, 0, 0.07);\n}\n\nbody.light_theme .otc-pair-search {\n  background: #fff;\n  color: #0f172a;\n  border-color: #e2e8f0;\n}\n\nbody.light_theme .otc-pair-row {\n  color: #0f172a;\n  border-bottom-color: #eef2f7;\n}\n\nbody.light_theme .otc-pair-row-head {\n  background: #f8fafc;\n  color: #64748b;\n}\n\nbody.light_theme .otc-pair-symbol {\n  color: #0f172a;\n}\n\nbody.light_theme .otc-history-btn {\n  color: #8a6a2f;\n}\n\nbody.light_theme .otc-request-row {\n  border-bottom-color: #eef2f7;\n}\n\nbody.light_theme .otc-request-head-row {\n  color: #64748b;\n}\n\n@media (max-width: 900px) {\n\n  html:has(.otc-trade-desk),\n  body:has(.otc-trade-desk) {\n    overflow: auto;\n  }\n\n  .otc-trade-desk.otc-desk-page {\n    height: auto;\n    max-height: none;\n    min-height: calc(100vh - 70px);\n    overflow: visible;\n  }\n\n  .otc-pair-list,\n  .otc-trade-desk .otc-request-list {\n    max-height: 70vh;\n  }\n\n  .otc-desk-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .otc-desk-nav {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  .otc-desk-nav button {\n    flex: 1;\n    text-align: center;\n  }\n\n  .otc-pair-toolbar,\n  .otc-pair-toolbar-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .otc-pair-filters,\n  .otc-pair-search {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .otc-pair-steps {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 700px) {\n\n  .otc-trade-amounts,\n  .otc-trade-footer,\n  .otc-pair-steps {\n    grid-template-columns: 1fr;\n  }\n}\n\n.otc-history-page {\n  min-height: calc(100vh - 70px);\n  background: #12151b;\n  color: #f5f5f5;\n  padding: 32px 20px 64px;\n}\n\n.otc-history-wrap {\n  width: min(1180px, 100%);\n  margin: 0 auto;\n}\n\n.otc-history-page h1 {\n  margin: 12px 0 6px;\n  font-size: 28px;\n}\n\n.otc-history-lead {\n  margin: 0 0 20px;\n  color: #9ca3af;\n}\n\n.otc-history-back {\n  display: inline-flex;\n  color: #d5a760;\n  font-weight: 700;\n  text-decoration: none;\n  background: transparent;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n}\n\n.otc-history-table {\n  overflow-x: auto;\n}\n\n.otc-history-table .trades-table td button {\n  border: 1px solid rgba(213, 167, 96, 0.5);\n  background: transparent;\n  color: #e7c98a;\n  border-radius: 999px;\n  padding: 6px 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.otc-history-table tr.is-open td {\n  background: rgba(213, 167, 96, 0.08);\n}\n\n.otc-history-detail {\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 16px;\n  background: #1c2128;\n  padding: 16px 18px;\n}\n\n.otc-history-detail h2 {\n  display: block;\n  margin: 12px 0 0;\n}\n\n.otc-history-detail p {\n  color: #9ca3af;\n  font-size: 13px;\n}\n\n.otc-history-detail {\n  margin-top: 8px;\n}\n\n.otc-history-detail dl {\n  display: grid;\n  grid-template-columns: 180px 1fr;\n  gap: 10px 16px;\n  margin: 16px 0 0;\n}\n\n.otc-history-detail dt {\n  color: #9ca3af;\n}\n\n.otc-history-detail dd {\n  margin: 0;\n}\n\n.otc-history-empty {\n  color: #9ca3af;\n}\n\nbody.light_theme .otc-history-page {\n  background: #f8fafc;\n  color: #0f172a;\n}\n\nbody.light_theme .otc-history-detail {\n  background: #fff;\n  border-color: #e5e7eb;\n  color: #0f172a;\n}\n\nbody.light_theme .otc-history-lead,\nbody.light_theme .otc-history-detail p,\nbody.light_theme .otc-history-detail dt,\nbody.light_theme .otc-history-empty {\n  color: #64748b;\n}\n\nbody.light_theme .otc-history-table .trades-table td button {\n  color: #8a6a2f;\n  background: #fff;\n}\n\nbody.light_theme .otc-history-table tr.is-open td {\n  background: #fff8ee;\n}\n\n@media (max-width: 767px) {\n\n  .otc-trade-overlay {\n    align-items: end;\n  }\n\n  .otc-trade-popup {\n    padding: 18px;\n    border-radius: 20px 20px 0px 0px;\n  }\n\n  .otc-history-detail dl {\n    grid-template-columns: 1fr;\n  }\n\n  .otc-trade-overlay .otc-trade-home-card {\n    border-radius: 18px 18px 0px 0px;\n  }\n\n  .otc-trade-desk .otc-rfq-card .otc-coin-label {\n    font-size: 12px;\n  }\n\n  .otc-trade-close {\n    padding: 0px;\n  }\n\n  .otc-trade-popup h2 {\n    font-size: 18px;\n  }\n\n  .otc-trade-lead {\n    font-size: 13px;\n  }\n\n  .otc-trade-overlay .otc-card-title {\n    font-size: 18px;\n  }\n\n  .otc-trade-overlay .otc-exchange-tabs button {\n    padding: 5px 20px;\n    font-size: 13px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
